import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from "@angular/core";
import { AppsService } from "src/app/shared/services/apps.service";
import { PermissionService } from "src/app/services/permission.service";
import moment from "moment";
import { differenceInCalendarDays } from "date-fns";
import * as L from "leaflet";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  DrawEvents,
  featureGroup,
  FeatureGroup,
  icon,
  latLng,
  tileLayer,
} from "leaflet";
import {
  circle,
  geoJSON,
  MapOptions,
  Layer,
  marker,
  Marker,
  polygon,
} from "leaflet";

import { LeafletLayersDemoModel } from "src/app/apps/maps/map-base/layers.model";
import { NzModalService } from "ng-zorro-antd/modal";
import "src/app/apps/maps/leaflet-ruler.js";
import { truncateWithEllipsis } from "@amcharts/amcharts4/.internal/core/utils/Utils";
import { ThemeService } from "ng2-charts";
import { FormControl, FormGroup } from "@angular/forms";
import { DatePipe } from "@angular/common";
// import '../lib/leaflet-search/leaflet-search.js'
import { jsPDF } from "jspdf";
// import html2canvas from 'html2canvas';
import { delay, timeout } from "rxjs/operators";
import * as turf from "@turf/turf";
import { truncate } from "fs";
import { TransferService } from "src/app/shared/services/transfer.service";
import { PlaybackService } from "src/app/apps/tracking/playback.service";
import { Router } from "@angular/router";
@Component({
  selector: "app-route-deviation-dashboard",
  templateUrl: "./route-deviation-dashboard.component.html",
  styleUrls: ["./route-deviation-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RouteDeviationDashboardComponent implements OnInit, AfterViewInit {
  header_label = {
    name: "Trips Dashboard",
  };
  filters: boolean = true;
  cameFromStateDashboard: boolean = false;
  @ViewChild("pdfSctn") pdfSctn: ElementRef;
  dateFormat = "dd/MM/yyyy";
  monthFormat = "yyyy/MM";
  selectedValue = null;
  showLdr = false;
  vehCtgrys;
  // True while the deviation-reason POST is in flight — disables the slider's
  // submit button and prevents duplicate writes from rapid clicks.
  isSavingRsn = false;
  wrds;
  postslctdDt;
  selectedCtgry = 0;
  slctdWrd = 0;
  slctdDt = new Date();
  curDate;
  curTblDate;
  rteDta;
  rdCnts;
  vehTrpLst: any;
  clntDtls: any;
  today = new Date();
  expandedCards: Set<number> = new Set();
  showSearchFilters: boolean = false;
  selectedSortId: any = null;
  selectedSortType: string = null;
  routemap: any = [];
  route_Polyline: any = [];
  tntLst: any = [];
  selectedtenant = 0;
  searchText;
  schdStartPBMarker: any = [];
  schdEndPBMarker: any = [];
  startPBMarker1: any;
  endPBMarker1: any;
  polylinePoints: any;
  actl_Polyline: any;
  ipMarker: any;
  popup;
  content;
  ipIcon = new L.Icon({
    iconUrl: "/assets/images/markers/mapIcons/m/colctn_pnt_nt_cvrd_m.png",
    iconSize: [42, 45],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  ipPts: any = [];
  mrkerPts: any;
  rtrstrng: string;
  shwAddBtn: boolean;
  rte_id: any;
  rte_nm: any;
  trp_sqnc_nu: any;
  fncDtls: any;
  cvrdIps: any = [];
  ipMarker1: any;
  strngarc: string;
  showsetRte: boolean;
  vehDupTrpLst: any = [];
  trp_schde_id: any;
  shwNodata: boolean;
  // Server-side pagination
  currentPage: number = 1;
  totalTrips: number = 0;
  pageSize: number = 50;
  searchDebounceTimer: any;
  rte_plyln_id: any;
  vendorList: any[];
  selectedvndr: any;
  userDtls: any;
  showVndr: boolean = false;
  clap_in: any;
  ShowClap: boolean = false;
  wardLst: any;
  wrdfncepolygon: L.Polygon<any>;
  wrdplypoint: any = [];
  schdStartMarker: any;
  schdEndMarker: any;
  checked: boolean = false;
  trvlDst;
  openSlider;
  slctdDtls: any = {};
  latlangs: any;
  dvtnForm: FormGroup;
  rdchked: boolean = false;
  timeFormat = "h:mm a";
  slctdstrt_tm;
  svmChkd: boolean = false;
  // for routemap
  startIcon = new L.Icon({
    iconUrl: "/assets/images/markers/playback/startPoint.png",
    iconSize: [33, 33],
    iconAnchor: [16, 28],
  });
  endIcon = new L.Icon({
    iconUrl: "/assets/images/markers/playback/endPoint.png",
    iconSize: [33, 33],
    iconAnchor: [16, 28],
  });
  startIcon1 = new L.Icon({
    iconUrl: "/assets/images/markers/playback/startPointbrwn.png",
    iconSize: [42, 45],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  endIcon1 = new L.Icon({
    iconUrl: "/assets/images/markers/playback/endPointbrwn.png",
    iconSize: [42, 45],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });
  shwAlWrds: boolean;
  allSchduleRtes: any = [];
  allTrvlRtes: any = [];
  allsched_Polyline: any;
  alltrvl_Polyline: any;
  // map polygon edit variables
  data = {
    toolbar: [],
  };
  that;
  map: any;
  optionsSpec: any = {
    layers: [
      {
        url: "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution: "Open Street Map",
      },
    ],
    zoom: 5,
    center: [46.879966, -121.726909],
  };

  LAYER_OSM = {
    id: "openstreetmap",
    name: "Open Street Map",
    enabled: true,
    layer: tileLayer("http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution: "Open Street Map",
    }),
  };

  LAYER_COUNTRIES = {
    id: "Countries",
    name: "Countries",
    enabled: true,
    layer: tileLayer(
      "http://{s}.tiles.mapbox.com/v3/milkator.press_freedom/{z}/{x}/{y}.png",
      {
        maxZoom: 5,
        attribution: "Map data &copy; 2013 Natural Earth",
      }
    ),
  };

  settings = {
    popover: { sec_title: "", sec_dscn: "" },
  };
  isVisible: boolean;
  rteSaveData: any;
  edtPolyline: any;
  updtPlyline: any;
  strngarcEdt: any;
  rtrstrngEdt: any;
  colors;
  editPlylneList: any = [];
  SlctdWrdPolyData: any = [];
  shwChckbox: boolean;
  addedNwLAyer: any;
  SearchItems: any[];
  asrt_id: any;
  strt_loc: any;
  end_loc: any;
  tripLoctns = [];
  tripEndLoctns: any = [];
  svmLst: any[];
  slctdSvm = 0;
  SlctdSvmPolyData: any = [];
  svmfncepolygon: L.Polygon<any>;
  svmplypoint: any = [];
  svmBndsLst = [];
  stoppageTime: number;
  finalSpdMrkrs: any = [];
  _parkingMarkersLayer = L.layerGroup();
  private parkingMarkerGroups: Map<
    string,
    {
      markers: L.Marker[];
      expanded: boolean;
      legs: L.Polyline[];
      baseLatLng: L.LatLng;
      lastClicked: L.Marker | null;
    }
  > = new Map();
  shwRdCks: boolean;
  rdTrips: any = [];
  date = new Date();
  Pbstrt_tm;
  Pbend_tm;
  pbRtData: any = [];
  startPBMarker: any;
  endPBMarker: any;
  PlyBk_Polyline: any;
  hoursDiff;
  timeDiff;
  tiles;
  schduleMarkers: any = [];
  schduleMarkersEnd: any = [];
  slctdend_tm: string;
  openOprtnSlider: boolean = false;
  oprtnsData: any = {};
  drawerWidth: number | string = 400;
  drawerWidthLg: number | string = 450;
  vhcleslst: any;
  selectedVehicle: any;
  chngdVhcle: any;
  vhclChngeRsn: string = "";
  ttlTrpsCnt: any = [];
  tripSvm: any;
  trpsvmBndsLst: any = [];
  svmplypoint2: any = [];
  svmfncepolygon2: L.Polygon<any>;
  strtMrkr: any;
  endMrkr: any;
  stpgDtls = false;
  stpdta: any;
  trvl = false;
  newArray: any = [];
  points: any = [];
  travelDist: string;
  stpgPnts: any = [];
  columnDefs: any[];
  prkngOpn: boolean;
  vehicle_nu: any;
  slctdTrpCrd: any;
  /* Per-role Dashboard-object permissions, populated from the
     `perm` field on /get_vehTrpsLst response (server middleware
     checkUser.vldSelect('Dashboard') attaches it via req.perm →
     df.formatSucessRes). Defaults let the list render on first
     paint before the response arrives; template uses insrt_in for
     Add / Set-as-master and updt_in for Settings / Parking / Edit.
     usrAcsErrMsg toggles on 404 from vldSelect (no Dashboard slct_in). */
  USER_PERMISSIONS: any = {
    slct_in: 1,
    insrt_in: 0,
    updt_in: 0,
    dlte_in: 0,
    exprt_in: 0,
  };
  usrAcsErrMsg: boolean = false;
  _strtFncBndLayer = L.layerGroup();
  _endFncBndLayer = L.layerGroup();
  strtFnceBnd: any;
  endFnceBnd: any;
  printbtn: any;
  OnHoverOption(optn) {
    // console.log("In OnHoverOption")
    // console.log(optn)
    this.settings.popover.sec_dscn = optn.dscn_tx;
    this.settings.popover.sec_title = optn.optn_nm;
  }

  @HostListener("window:resize")
  onResize() {
    this.setDrawerWidths();
  }

  setDrawerWidths() {
    const width = window.innerWidth;
    if (width <= 640) {
      this.drawerWidth = "90%";
      this.drawerWidthLg = "95%";
    } else if (width <= 1024) {
      this.drawerWidth = "70%";
      this.drawerWidthLg = "75%";
    } else {
      this.drawerWidth = 400;
      this.drawerWidthLg = 450;
    }
  }

  map_stng: any = {
    fnce_grp_hndlr_tx: "fences",
    show_sidebar: false,
    show_detail_sidebar: false,
    show_drill_sidebar: false,
    show_grid: false,
    show_build_sidebar: false,
    undo_flag: false,
    show_coordinates: true,
  };
  map_data: any = {
    sidebar_hdng: "",
    sidebar_detail_hdng: "",
    sidebar_drill_hdng: "",
    selected_toolbar_hndr_tx: "",
    fences_groups: [],
    fence_list: [],
    "map_data.mrkers_list_list": [],
  };
  edit_fence: any = {
    fnce_type: "",
    crtd_fnce_type: "",
    fnce_nm: "",
    dscn_tx: "",
    imge_url_tx: "",
    Opacity: "30",
    FillOpacity: "30",
    stroke: 2,
    weight: 2,
    dashArray: "2,2",
    color: "#8c90f2",
    fill: true,
    fillColor: "#8c90f2",
    stroke_type: "DIRECTED_ROUTE",
    marker_id: 1,
    marker_nm: "RED_MARKER",
    marker_icn_url: "007-placeholder.svg",
    lat: null,
    lng: null,
    latlng_array: [],
    radius: null,
  };
  fnce_drawer = {
    circleDrawer: null,
    polylineDrawer: null,
    polygonDrawer: null,
    markerDrawer: null,
  };
  master_data: any = {
    marker_icons: [],
  };
  layers: Layer[];
  model = new LeafletLayersDemoModel([this.LAYER_OSM], this.LAYER_OSM.id);
  leafletOptions = {
    center: latLng(17.004393, 81.783325),
    zoom: 15,
    maxZoom: 19,
  };
  poly = [];

  centerMap(e) {
    // console.log("e.latlng")
    // console.log(e.latlng)
    // console.log("this.options.center")
    // console.log(this["options"].center)
    this["options"].center = e.latlng;
    // console.log(this)
    //this.map.panTo(e.latlng);
  }

  // zoomIn(e) {
  //   this.map.zoomIn();
  // }

  // zoomOut(e) {
  //   this.map.zoomOut();
  // }
  editablLayers = new FeatureGroup();
  tileLayers = [
    {
      lyr_id: 1,
      lyr_nm: "Street",
      lyr_url: "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      lyrSlct: true,
    },
    {
      lyr_id: 2,
      lyr_nm: "Satellite",
      lyr_url: "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
      lyrSlct: false,
    },
  ];
  constructor(
    public apiServ: AppsService,
    private message: NzMessageService,
    private modal: NzModalService,
    public datepipe: DatePipe,
    public TransfereService: TransferService,
    private playbackService: PlaybackService,
    private router: Router,
    public perms: PermissionService
  ) {
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.tntLst = this.clntDtls[0].tnts;
    this.selectedtenant = this.tntLst.length === 1 ? this.tntLst[0].tnt_id : 0;
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    // console.log(this.userDtls);

    this.clap_in = this.userDtls.clap_in;
    if (this.clap_in == 1) {
      this.ShowClap = true;
      this.selectedvndr = 0;
    }
    if (this.selectedtenant != 7) {
      this.shwAlWrds = true;
    } else {
      this.shwAlWrds = false;
    }
    this.colors = [
      { id: 1, clr: "#9b329b" },
      { id: 2, clr: "#104576" },
      { id: 3, clr: "brown" },
      { id: 4, clr: "#d78d07" },
      { id: 5, clr: "#515e56" },
      { id: 6, clr: "indigo" },
      { id: 7, clr: "#8f058f" },
      { id: 8, clr: "maroon" },
      { id: 9, clr: "navy" },
      { id: 10, clr: "olive" },
      { id: 11, clr: "olive" },
      { id: 12, clr: "#5a045a" },
      { id: 13, clr: "#30D5C8" },
      { id: 14, clr: "#efefef" },
      { id: 15, clr: "teal" },
      { id: 16, clr: "#303f9f" },
      { id: 17, clr: "#df4f68" },
    ];
  }
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };
  ngOnInit() {
    this.setDrawerWidths();
    this.slctdDt = new Date();
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTblDate = moment(this.slctdDt).format("DD-MM-YYYY");
    this.get_vehCategories();
    this.get_wards();
    if (this.selectedtenant != 7) {
      // this.selectWard(0, this.curDate);
    }
    this.getVendors();
    this.getTripLocations();
    this.getSachivalayams();
    // if (this.userDtls.rle_id != 37) {
    //   this.selectCategory(0, this.curDate);
    //   this.get_rtDvtdTrips(this.curDate);
    // }
    this.dvtnForm = new FormGroup({
      drvr_cntctd_in: new FormControl(""),
      rte_dvtn_acpt_in: new FormControl(""),
      dvtn_rsn_tx: new FormControl(""),
    });
    this.getVehicles();
    this.get_totalTripsCount();
    this.slctdTrpCrd = this.TransfereService.getLoclData("grdta");
    console.log(this.slctdTrpCrd);
    this.TransfereService.ClearLocalData("grdta");

    // Check if navigated from state-trips-dashboard with pre-selected ULB
    const preSelectedTnt = this.TransfereService.getLoclData(
      "slctd_tnt_frm_state"
    );
    if (preSelectedTnt !== null && preSelectedTnt !== undefined) {
      this.cameFromStateDashboard = true;
      this.TransfereService.ClearLocalData("slctd_tnt_frm_state");
      this.selectedtenant = preSelectedTnt;
      this.ontntSelect(preSelectedTnt);
    }
  }
  get_totalTripsCount() {
    this.ttlTrpsCnt = [];
    let postData: any = {
      dt: this.curDate,
      tnt_in: 0,
    };
    if (this.selectedtenant > 0) {
      postData.slctd_tnt = this.selectedtenant;
    }
    let rte = `dashboard/enterprise/ttlTrips/state`;
    this.apiServ.post(postData, rte).subscribe(
      (res) => {
        let res_data = res["data"];
        if (res_data && res_data.length > 0) {
          this.ttlTrpsCnt = res["data"];
          // Compute total vehicles (trips assigned + not assigned)
          this.ttlTrpsCnt[0].ttl_vhcls =
            (this.ttlTrpsCnt[0].trps_asgnd_vhcls || 0) +
            (this.ttlTrpsCnt[0].trps_not_asgnd_vhcls || 0);
          this.ttlTrpsCnt[0].primary_ttl_vhcls =
            (this.ttlTrpsCnt[0].primary_trps_asgnd_vhcls || 0) +
            (this.ttlTrpsCnt[0].primary_trps_not_asgnd_vhcls || 0);
          this.ttlTrpsCnt[0].secondary_ttl_vhcls =
            (this.ttlTrpsCnt[0].secondary_trps_asgnd_vhcls || 0) +
            (this.ttlTrpsCnt[0].secondary_trps_not_asgnd_vhcls || 0);
        }
      },
      (err) => {}
    );
  }
  ontntSelect(value) {
    // console.log(value);
    if (value === 0) {
      this.selectedtenant = 0;
    }
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.tntLst.length; i++) {
      if (this.tntLst[i].tnt_id === value) {
        this.selectedtenant = this.tntLst[i].tnt_id;
      }
    }

    // Clear all previous plotted polylines and markers from the map
    this.clearRouteMapLayers();

    // Reset ward polygon layers
    if (
      this.wrdplypoint &&
      this.routemap &&
      typeof this.routemap.removeLayer === "function"
    ) {
      for (var k = 0; k < this.wrdplypoint.length; k++) {
        this.routemap.removeLayer(this.wrdplypoint[k].ply);
      }
      this.wrdplypoint = [];
    }
    // Reset sachivalayam polygon layers
    if (
      this.svmplypoint &&
      this.routemap &&
      typeof this.routemap.removeLayer === "function"
    ) {
      for (var k = 0; k < this.svmplypoint.length; k++) {
        this.routemap.removeLayer(this.svmplypoint[k]);
      }
      this.svmplypoint = [];
    }

    // Reset filter selections
    this.selectedCtgry = 0;
    this.slctdWrd = 0;
    this.slctdSvm = 0;
    this.strt_loc = undefined;
    this.end_loc = undefined;
    this.searchText = "";
    this.vehTrpLst = [];
    this.vehDupTrpLst = [];

    this.getSachivalayams();
    this.get_rtDvtdTrips(this.curDate);
    this.selectCategory(0, this.curDate);
    this.getVehicles();
    this.getVendors();
    this.get_wards();
    this.get_totalTripsCount();
  }

  ngAfterViewInit() {
    // Initialize map after view is fully initialized - this ensures DOM is ready
    this.initializeMap();
  }

  initializeMap() {
    // Use a more reliable approach with multiple checks
    const initMap = () => {
      const mapElement = document.getElementById("routeDevtmap");
      if (!mapElement) {
        // Retry if element not found
        setTimeout(initMap, 200);
        return;
      }

      // Check if element is visible and has dimensions
      const rect = mapElement.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        // Element exists but has no dimensions, retry
        setTimeout(initMap, 200);
        return;
      }

      // Proceed with initialization
      this.initialize();
    };

    // Start initialization
    setTimeout(initMap, 100);
  }

  initialize = function () {
    this.usrDtls = JSON.parse(localStorage.getItem("wto_clients"));
    // console.log(this.usrDtls);
    //----------Map Initialization (Default openstreetmap  Layer) -- Leaflet OS Playback----------//
    try {
      // Check if map container exists and is visible
      const mapElement = document.getElementById("routeDevtmap");
      if (!mapElement) {
        console.error("Map container #routeDevtmap not found.");
        return;
      }

      // Verify element has dimensions
      const rect = mapElement.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        console.error(
          "Map container has no dimensions. Width:",
          rect.width,
          "Height:",
          rect.height
        );
        // Retry after a short delay
        setTimeout(() => {
          if (document.getElementById("routeDevtmap")) {
            this.initialize();
          }
        }, 300);
        return;
      }

      // Check if map is already initialized and remove it
      if (this.routemap && typeof this.routemap.remove === "function") {
        try {
          this.routemap.remove();
        } catch (e) {
          console.warn("Error removing existing map:", e);
        }
      }

      this.routemap = L.map("routeDevtmap", {
        center: [this.usrDtls[0].lat, this.usrDtls[0].lng],
        zoom: 3,
        fullscreenControl: true,
      });
      this.routemap.setView([this.usrDtls[0].lat, this.usrDtls[0].lng], 13);

      // const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      //   // maxZoom: 15,
      //   // minZoom: 3,
      //   attribution: ''
      // });
      const tiles = L.tileLayer(
        "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
        {
          maxZoom: 20,
          minZoom: 3,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          attribution: "",
        }
      );
      tiles.addTo(this.routemap);

      // Critical: Invalidate size after tiles are added to ensure map renders properly
      // This must be done after the DOM is fully ready and tiles are loaded
      setTimeout(() => {
        if (
          this.routemap &&
          typeof this.routemap.invalidateSize === "function"
        ) {
          this.routemap.invalidateSize();
        }
      }, 500);

      // Additional invalidation after a longer delay to handle any async rendering
      setTimeout(() => {
        if (
          this.routemap &&
          typeof this.routemap.invalidateSize === "function"
        ) {
          this.routemap.invalidateSize();
        }
      }, 1000);

      // Add window resize listener to ensure map resizes properly
      if (typeof window !== "undefined") {
        window.addEventListener("resize", () => {
          if (
            this.routemap &&
            typeof this.routemap.invalidateSize === "function"
          ) {
            setTimeout(() => {
              this.routemap.invalidateSize();
            }, 100);
          }
        });
      }

      const fullscreenButton = L.control({ position: "topleft" });
      fullscreenButton.onAdd = (map) => {
        const div = L.DomUtil.create(
          "div",
          "leaflet-control-fullscreen leaflet-bar leaflet-control"
        );
        const link = L.DomUtil.create(
          "a",
          "leaflet-control-fullscreen-button",
          div
        );
        link.href = "#";
        link.title = "View Fullscreen";
        link.innerHTML = '<i class="fas fa-expand"></i>';

        L.DomEvent.on(link, "click", L.DomEvent.stopPropagation)
          .on(link, "click", L.DomEvent.preventDefault)
          .on(link, "click", () => {
            if (!document.fullscreenElement) {
              const element = document.getElementById("routeDevtmap");
              if (element && element.requestFullscreen) {
                element.requestFullscreen();
              }
            } else {
              if (document.exitFullscreen) {
                document.exitFullscreen();
              }
            }
          });

        document.addEventListener("fullscreenchange", () => {
          if (document.fullscreenElement) {
            link.innerHTML = '<i class="fas fa-compress"></i>';
            link.title = "Exit Fullscreen";
            setTimeout(() => this.routemap.invalidateSize(), 200);
          } else {
            link.innerHTML = '<i class="fas fa-expand"></i>';
            link.title = "View Fullscreen";
            setTimeout(() => this.routemap.invalidateSize(), 200);
          }
        });

        return div;
      };
      fullscreenButton.addTo(this.routemap);
    } catch (e) {
      console.log("please check map Initialization of leaflet:" + e);
    }
    // this.setVehicleMarkers();
  };
  chklyrSlct(evt) {
    this.tileLayers.forEach((t) => {
      if (t.lyr_id == evt.lyr_id) {
        t.lyrSlct = true;
        if (this.tiles) {
          this.map.removeLayer(this.tiles);
        }
        this.tiles = L.tileLayer(t.lyr_url, {
          maxZoom: 24,
          minZoom: 3,
          subdomains: ["mt0", "mt1", "mt2", "mt3"],
          attribution: "",
        });
        this.tiles.addTo(this.map);
      } else {
        t.lyrSlct = false;
      }
    });
  }
  get_vehCategories(): any {
    // this.showLdr = true;
    this.apiServ
      .get(`dashboard/enterprise/${this.selectedtenant}/get_vehCtgrys`)
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            var res_data = res["data"];
            if (res_data && res_data.length > 0) {
              this.vehCtgrys = res["data"];
              // console.log(this.vehCtgrys)
            }
            // this.showLdr = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }
  get_wards(): any {
    // this.showLdr = true;
    this.apiServ.get(`drivers/vehicles/wards/${this.selectedtenant}`).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          if (res_data && res_data.length > 0) {
            this.wrds = res["data"];
            // console.log(this.wrds)
          }
          // this.showLdr = false;
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  getSachivalayams() {
    // this.showLdr = true;
    this.svmLst = [];
    this.apiServ
      .get(`tripschedule/tenant/${this.selectedtenant}/svmLst`)
      .subscribe(
        (res) => {
          if (res["status"] == 200) {
            // this.showLdr = false;
            this.svmLst = res["data"];
            if (this.userDtls.rle_id == 37) {
              this.slctdSvm = this.svmLst[0].svm_id;
              this.selectSachvalayam(this.slctdSvm, this.curDate);
              this.get_rtDvtdTrips(this.curDate);
              // this.selectCategory(0, this.curDate);
            } else {
              this.slctdSvm = 0;
            }
          }
        },
        (err) => {
          console.log("In errorr");
        }
      );
  }
  get_rtDvtdTrips(funDt?): any {
    // this.showLdr = true;
    this.slctdDt = funDt;
    // console.log(this.slctdDt);
    // console.log(this.selectedtenant);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    // console.log(this.curDate);
    this.postslctdDt = {
      dt: this.curDate,
      tnt_in: 1,
      rte_dev_in: 0,
      selectedtenant: this.selectedtenant,
      vndr_id: this.selectedvndr,
      wrd_id: this.slctdWrd,
      svm_id: this.slctdSvm,
    };
    console.log(this.postslctdDt);
    let rte = `dashboard/enterprise/get_rdTripsCnt`;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          var res_data = res["data"];
          // this.showLdr = false;
          if (res_data && res_data.length > 0) {
            this.rdCnts = res["data"];
            // console.log(this.rdCnts)
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  onChange(e): void {
    // console.log('onChange: ', e);
    this.slctdDt = e;
    // console.log('slctdDt: ', this.slctdDt);
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.curTblDate = moment(this.slctdDt).format("DD-MM-YYYY");
    // console.log(this.curDate, this.selectedCtgry);
    this.selectCategory(0, this.curDate);
    // this.selectWard(0, this.curDate);
    this.get_rtDvtdTrips(this.curDate);
  }

  selectCategory(evnt, dt?) {
    this.showLdr = true;
    this.clearRouteMapLayers();
    this.vehTrpLst = [];
    this.vehDupTrpLst = [];
    // console.log(evnt, this.curDate);
    this.selectedCtgry = evnt;
    this.currentPage = 1;
    this.loadTrips();
  }

  loadTrips() {
    this.showLdr = true;
    this.clearRouteMapLayers();
    this.vehTrpLst = [];
    this.postslctdDt = {
      dt: this.curDate,
      id: this.selectedCtgry,
      rte_dev_in: 0,
      tnt_id: this.selectedtenant,
      vndr_id: this.selectedvndr,
      wrd_id: this.slctdWrd,
      strt_fnce_id: this.strt_loc,
      end_fnce_id: this.end_loc,
      svm_id: this.slctdSvm,
      page: this.currentPage,
      pageSize: this.pageSize,
      searchText: this.searchText || "",
      trp_type_id: this.selectedSortId,
      sort_type: this.selectedSortType || "",
      drvr_cntctd: this.rdchked ? 1 : 0,
    };
    console.log(this.postslctdDt);
    const rte = `dashboard/enterprise/get_vehTrpsLst`;
    this.usrAcsErrMsg = false;
    this.apiServ.post(this.postslctdDt, rte).subscribe(
      (res) => {
        console.log(res);
        /* 404 = ACCESS_DENIED from vldSelect('Dashboard') — the user's role
         has no slct_in on the Dashboard object. Show the same "no access"
         message pattern used elsewhere (see asset-types.component.ts). */
        if (res["status"] == 404) {
          this.usrAcsErrMsg = true;
          this.showLdr = false;
          this.shwNodata = true;
          this.totalTrips = 0;
          return;
        }
        if (res["status"] == 200) {
          /* Capture role→object permissions attached by vldSelect middleware.
           Template gates Settings / Parking / Add / Edit / Set-as-master
           on insrt_in / updt_in. Falls back to the default (no-write)
           permissions when the field is missing. */
          if (res["perm"] && res["perm"][0]) {
            this.USER_PERMISSIONS = res["perm"][0];
          }
          var res_data = res["data"];
          if (res_data && res_data.data && res_data.data.length > 0) {
            this.shwNodata = false;
            this.totalTrips = res_data.total;
            this.vehTrpLst = res_data.data;
            console.log(this.vehTrpLst);

            this.vehDupTrpLst = this.vehTrpLst;
            /* Deep-link path: caller passed a specific trip via
             TransfereService('grdta') — narrow the list to that one card
             AND auto-open its playback, because "open this specific trip"
             is the whole point of the deep link. Default (no deep link)
             flow leaves playback for user click, per the new spec. */
            var isDeepLink = false;
            if (this.slctdTrpCrd && this.slctdTrpCrd.trp_rn_id != undefined) {
              this.vehDupTrpLst.forEach((d) => {
                if (d.trp_rn_id == this.slctdTrpCrd.trp_rn_id) {
                  this.vehTrpLst = [d];
                  isDeepLink = true;
                }
              });
            }

            for (let v = 0; v < this.vehTrpLst.length; v++) {
              this.vehTrpLst[v].grp_nm = this.vehTrpLst[v].asrt_nm;
            }
            if (this.selectedtenant != 7) {
              this.vehTrpLst.forEach((element, index) => {
                element["clr_obj"] = element["clr_obj"] =
                  this.colors[index % this.colors.length].clr;
              });
              for (let v = 0; v < this.vehTrpLst.length; v++) {
                this.vehTrpLst[v].grp_nm = this.vehTrpLst[v].wrd_nm;
              }
              if (this.checked == true) {
                this.getWrdbyAsrt(this.vehTrpLst[0].asrt_id);
              }
            }
            this.showLdr = false;

            /* Playback auto-fetch REMOVED for the general case — used to be
             `getTripMap(this.vehTrpLst[0], …)` here on every load, which
             hit the /playback/vehicle/playback API even when the user only
             wanted to browse the card list. Playback now fires only via
             the card's (click) handler. Deep-link opens still auto-play. */
            if (isDeepLink && this.vehTrpLst.length > 0) {
              this.getTripMap(this.vehTrpLst[0], this.slctdDt);
            }
          } else {
            this.showLdr = false;
            this.shwNodata = true;
            this.totalTrips = 0;
          }
        }
      },
      (err) => {
        console.log(err);
        this.showLdr = false;
      }
    );
  }

  getTotalPages(): number {
    return Math.ceil(this.totalTrips / this.pageSize) || 1;
  }

  onPageChange(page: number) {
    if (page < 1 || page > this.getTotalPages()) return;
    this.currentPage = page;
    this.loadTrips();
  }

  selectWard(evnt, dt?) {
    this.clearRouteMapLayers();
    this.vehTrpLst = [];
    this.vehDupTrpLst = [];
    if (evnt > 0) {
      this.shwChckbox = true;
      this.checked = true;
    } else {
      this.checked = false;
      this.shwChckbox = false;
      this.SlctdSvmPolyData = [];
    }
    this.slctdWrd = evnt;
    this.currentPage = 1;
    this.loadTrips();
  }
  selectSachvalayam(evnt, dt?) {
    this.clearRouteMapLayers();
    this.vehTrpLst = [];
    this.vehDupTrpLst = [];
    if (evnt > 0) {
      this.shwChckbox = true;
    } else {
      this.checked = false;
      this.shwChckbox = false;
      this.SlctdWrdPolyData = [];
    }
    this.slctdSvm = evnt;
    this.currentPage = 1;
    this.getSvmBounds(evnt);
    this.loadTrips();
  }
  getSvmBounds(svm_id) {
    this.svmBndsLst = [];
    if (this.svmplypoint) {
      for (var k = 0; k < this.svmplypoint.length; k++) {
        this.routemap.removeLayer(this.svmplypoint[k].ply);
      }
    }
    // console.log(this.slctdSvm)
    // this.apiServ.get(`playback/svm/bounds/${this.slctdSvm}`).subscribe((res) => {
    //   if (res['status'] === 200) {
    this.svmLst.forEach((s) => {
      if (s.svm_id == svm_id) {
        this.svmBndsLst.push(s);
      }
    });

    // console.log(this.svmBndsLst)
    for (var l = 0; l < this.svmBndsLst.length; l++)
      if (this.svmBndsLst[l].fnce_arc_lne_tx) {
        this.svmfncepolygon = L.polygon(
          JSON.parse(this.svmBndsLst[l].fnce_arc_lne_tx) as [],
          { color: this.svmBndsLst[l].fncs_clr_cd }
        )
          .addTo(this.routemap)
          .bindTooltip(this.svmBndsLst[l].svm_nm, {
            permanent: true,
            opacity: 0.7,
          })
          .openTooltip();
        this.svmplypoint.push({
          ply: this.svmfncepolygon,
          svm_id: this.svmBndsLst[l].svm_id,
        });
        this.routemap.fitBounds(this.svmfncepolygon.getBounds());
      }
    //   }
    // }, (err) => {
    //   console.log('In errorr');
    // });
  }
  getTripMap(c, dt) {
    console.log(this.checked);
    this.rte_nm = "";
    this.showLdr = true;
    console.log(c, dt);

    // Clear previous parking markers before loading new trip
    if (this._parkingMarkersLayer) {
      this._parkingMarkersLayer.clearLayers();
      this.routemap.removeLayer(this._parkingMarkersLayer);
    }
    this.finalSpdMrkrs = [];
    this._parkingMarkersLayer = L.layerGroup();

    // console.log(this.schdStartPBMarker)
    this.rte_nm = c.rte_nm;
    this.trp_sqnc_nu = c.trp_sqnc_nu;
    this.trp_schde_id = c.trp_schde_id;
    this.rte_plyln_id = c.rte_plyln_id;
    this.asrt_id = c.asrt_id;
    if (this.clntDtls[0].clnt_id != 7) {
      this.getWrdbyAsrt(c.asrt_id);
      // }else{
      //   this.getSvmBounds(c.svm_id);
    }

    this.vehTrpLst.forEach((ele) => {
      ele.shwAddBtn = false;
      this.showsetRte = false;
      if (ele.trp_schde_id != c.trp_schde_id) {
        ele.isSelected = false;
      } else {
        ele.isSelected = true;
      }
    });
    this.vehTrpLst.forEach((ele) => {
      if (ele.rte_id == c.rte_id && ele.trp_rn_id == c.trp_rn_id) {
        // console.log(ele.trp_rn_id, c.trp_rn_id, ele.rte_id, c.rte_id)
        ele.shwEdtBtn = true;
        // console.log(ele.shwEdtBtn)
      } else {
        ele.shwEdtBtn = false;
      }
    });

    // Lazy-load geometry on-demand if not already cached on card
    if (!c.rte_arc_lne_tx && c.has_rte_plyln == 1) {
      this.apiServ
        .post(
          { trp_schde_id: c.trp_schde_id },
          "dashboard/enterprise/get_vehTripGeom"
        )
        .subscribe((geomRes) => {
          if (geomRes && geomRes["data"] && geomRes["data"].length > 0) {
            c.rte_arc_lne_tx = geomRes["data"][0].rte_arc_lne_tx;
            c.strt_fnce_bnd = geomRes["data"][0].strt_fnce_bnd;
            c.end_fnce_bnd = geomRes["data"][0].end_fnce_bnd;
          }
          if (c.rte_arc_lne_tx) {
            this.polylinePoints = JSON.parse(c.rte_arc_lne_tx);
          }
          this._renderTripOnMap(c, dt);
        });
      return;
    }
    if (
      c.rte_arc_lne_tx &&
      c.rte_arc_lne_tx != null &&
      c.rte_arc_lne_tx != undefined
    ) {
      this.polylinePoints = JSON.parse(c.rte_arc_lne_tx);
    } else {
      // this.showLdr = false;
    }
    this._renderTripOnMap(c, dt);
  }

  _renderTripOnMap(c, dt) {
    this.getCvrdFncs(c);

    if (this.checked == false) {
      this.SlctdWrdPolyData = [];
      this.SlctdSvmPolyData = [];
      if (this.schdStartMarker) {
        this.routemap.removeLayer(this.schdStartMarker);
      }

      if (this.schdEndMarker) {
        this.routemap.removeLayer(this.schdEndMarker);
      }

      // ----------Fence Start Area (flag position) -- Leaflet OS ----------//
      var startIcon = new L.Icon({
        iconUrl: "/assets/images/markers/mapIcons/m/location.png",
        iconSize: [33, 33],
        iconAnchor: [16, 28],
      });

      if (c.strt_fnce_lat != undefined && c.strt_fnce_lng != undefined) {
        this.schdStartMarker = L.marker([c.strt_fnce_lat, c.strt_fnce_lng], {
          icon: startIcon,
        })
          .addTo(this.routemap)
          .bindTooltip(c.strt_fnce_nm, { permanent: true, opacity: 0.7 })
          .openTooltip();
      }

      // ----------Fence END Area (flag position) -- Leaflet OS ----------//
      var endIcon = new L.Icon({
        iconUrl: "/assets/images/markers/mapIcons/m/location.png",
        iconSize: [33, 33],
        iconAnchor: [16, 28],
      });

      if (c.end_fnce_lat && c.end_fnce_lng) {
        this.schdEndMarker = L.marker([c.end_fnce_lat, c.end_fnce_lng], {
          icon: endIcon,
        })
          .addTo(this.routemap)
          .bindTooltip(c.end_fnce_nm, { permanent: true, opacity: 0.7 })
          .openTooltip();
      }

      if (this.route_Polyline != undefined) {
        this.routemap.removeLayer(this.route_Polyline);
      }
      // });

      if (this.schduleMarkers) {
        for (let s = 0; s < this.schduleMarkers.length; s++) {
          this.routemap.removeLayer(this.schduleMarkers[s].strtMrkr);
        }
      }
      if (this.schduleMarkersEnd) {
        for (let s = 0; s < this.schduleMarkersEnd.length; s++) {
          this.routemap.removeLayer(this.schduleMarkersEnd[s].endMrkr);
        }
      }

      if (this.schdStartPBMarker) {
        this.routemap.removeLayer(this.schdStartPBMarker);
      }

      if (this.schdEndPBMarker) {
        this.routemap.removeLayer(this.schdEndPBMarker);
      }
      // ----------Fence Start Area (flag position) -- Leaflet OS ----------//
      var startIcon = new L.Icon({
        iconUrl: "/assets/images/markers/playback/startPoint.png",
        iconSize: [42, 45],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });
      if (this.polylinePoints && this.polylinePoints[0]) {
        // console.log(this.polylinePoints[0])
        this.schdStartPBMarker = L.marker(this.polylinePoints[0], {
          icon: startIcon,
        }).addTo(this.routemap);
      }
      this.schduleMarkers.push({ strtMrkr: this.schdStartPBMarker });

      // ----------Fence END Area (flag position) -- Leaflet OS ----------//
      var endIcon = new L.Icon({
        iconUrl: "/assets/images/markers/playback/endPoint.png",
        iconSize: [42, 45],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
      });
      if (this.polylinePoints) {
        let k = this.polylinePoints.length - 1;
        if (this.polylinePoints[k]) {
          this.schdEndPBMarker = L.marker(this.polylinePoints[k], {
            icon: endIcon,
          }).addTo(this.routemap);
        }
      }
      this.schduleMarkersEnd.push({ endMrkr: this.schdEndPBMarker });

      if (c.rte_arc_lne_tx && c.rte_arc_lne_tx != null) {
        this.route_Polyline = L.polyline(JSON.parse(c.rte_arc_lne_tx), {
          color: "#008000",
          weight: 5,
          lineCap: "butt",
          opacity: 0.6,
          smoothFactor: 10.0,
          lineJoin: "round",
        }).addTo(this.routemap);
        this.routemap.fitBounds(this.route_Polyline.getBounds());
      }

      if (
        c.start_tm != "0000-00-00 00:00:00" &&
        c.end_tm != "0000-00-00 00:00:00"
      ) {
        this.curDate = moment(dt).format("YYYY-MM-DD");
        this.rte_id = c.rte_id;
        let endTimep;
        console.log(c.actl_end_ts, c.end_tm);
        // if (c.actl_end_ts != null) {
        //   endTimep = c.actl_end_ts;
        // } else if (dt < this.curDate && c.actl_end_ts != null) {
        //   endTimep = c.end_tm;
        // } else if (dt < this.curDate && c.actl_end_ts == null) {
        //   endTimep = c.end_tm;
        // } else {
        //   endTimep = this.curDate + " " + moment().format('HH:mm');
        // }
        if (c.end_tm != null) {
          endTimep = c.end_tm;
        } else {
          endTimep = this.curDate + " " + moment().format("HH:mm");
        }
        this.postslctdDt = {
          dt: this.curDate,
          data: {
            dev_imei_nu: c.dev_imei_nu,
            start_tm: this.datepipe.transform(c.start_tm, "yyyy-MM-dd HH:mm"),
            end_tm: this.datepipe.transform(endTimep, "yyyy-MM-dd HH:mm"),
          },
        };
        // Clear parking markers layer group before getting new route
        if (this._parkingMarkersLayer) {
          this._parkingMarkersLayer.clearLayers();
          this.routemap.removeLayer(this._parkingMarkersLayer);
        }
        this.finalSpdMrkrs = [];
        this._parkingMarkersLayer = L.layerGroup();
        // Getting travelled route line arc
        const rte = `dashboard/enterprise/get_tripTrvlRoute`;
        this.apiServ.post(this.postslctdDt, rte).subscribe(
          (res) => {
            this.showLdr = true;
            this.trvlDst = 0;
            if (res["status"] == 200) {
              var res_data = res["data"];
              if (res_data && res_data.length > 0) {
                this.showLdr = false;
                this.rteDta = res["data"];
                this.trvl = true;
                console.log(
                  "Route data received:",
                  this.rteDta.length,
                  "points"
                );

                // Calculate travel distance
                this.trvlDst = Math.round(
                  this.rteDta[this.rteDta.length - 1].odmtr_ct -
                    this.rteDta[0].odmtr_ct
                );

                // Build parking markers identical to playback component behaviour
                const playbackStyledPoints = this.buildPlaybackParkingPoints(
                  this.rteDta,
                  c
                );
                this.plotParkingMarkers(playbackStyledPoints, c.asrt_nm);

                // for stoppage time
                // console.log(this.rteDta)
                var restr = "";
                this.rtrstrng = "";
                var arcrestr = "";

                var tmp;
                for (var i = 0; i < this.rteDta.length; i++) {
                  restr +=
                    restr == ""
                      ? "[" +
                        this.rteDta[i].lat +
                        "," +
                        this.rteDta[i].lng +
                        "]"
                      : ",[" +
                        this.rteDta[i].lat +
                        "," +
                        this.rteDta[i].lng +
                        "]";
                  this.rtrstrng = restr;
                  arcrestr +=
                    arcrestr == ""
                      ? this.rteDta[i].lng + " " + this.rteDta[i].lat
                      : "," + this.rteDta[i].lng + " " + this.rteDta[i].lat;
                }

                var lstrng = arcrestr.split("[").join("");
                var lstrng2 = lstrng.split("]").join("");
                this.strngarc = lstrng2;
                this.vehTrpLst.forEach((ele) => {
                  if (
                    ele.rte_id == c.rte_id &&
                    this.rtrstrng.length > 0 &&
                    ele.trp_rn_id == c.trp_rn_id
                  ) {
                    ele.shwAddBtn = true;

                    // ele.edtPlybckStrng = '[' + this.rtrstrng + ']';
                    this.showsetRte = true;
                  } else {
                    ele.shwAddBtn = false;
                    // ele.shwTrvl = true
                    this.showsetRte = false;
                  }
                });
                // console.log(this.vehTrpLst)
                if (this.actl_Polyline) {
                  this.routemap.removeLayer(this.actl_Polyline);
                }
                if (this.startPBMarker1) {
                  this.routemap.removeLayer(this.startPBMarker1);
                }
                if (this.endPBMarker1) {
                  this.routemap.removeLayer(this.endPBMarker1);
                }
                // ----------Fence Start Area (flag position) -- Leaflet OS ----------//
                var startIcon1 = new L.Icon({
                  iconUrl: "/assets/images/markers/playback/startPointbrwn.png",
                  iconSize: [42, 45],
                  iconAnchor: [12, 41],
                  popupAnchor: [1, -34],
                  shadowSize: [41, 41],
                });
                if (this.rteDta[0].lat && this.rteDta[0].lng) {
                  this.startPBMarker1 = L.marker(
                    [this.rteDta[0].lat, this.rteDta[0].lng],
                    {
                      icon: startIcon1,
                    }
                  ).addTo(this.routemap);

                  this.startPBMarker1
                    .bindPopup(
                      "<b>Vehicle No : " +
                        c.asrt_nm +
                        "<br>Starting Time : " +
                        this.rteDta[0].Signal +
                        "</b>"
                    )
                    .addTo(this.routemap);
                }

                // ----------Fence END Area (flag position) -- Leaflet OS ----------//
                if (
                  this.rteDta[this.rteDta.length - 1].lat &&
                  this.rteDta[this.rteDta.length - 1].lng
                ) {
                  var endIcon1 = new L.Icon({
                    iconUrl: "/assets/images/markers/playback/endPointbrwn.png",
                    iconSize: [42, 45],
                    iconAnchor: [12, 41],
                    popupAnchor: [1, -34],
                    shadowSize: [41, 41],
                  });
                  var k1 = this.rteDta.length - 1;
                  this.endPBMarker1 = L.marker(this.rteDta[k1], {
                    icon: endIcon1,
                  }).addTo(this.routemap);

                  this.endPBMarker1
                    .bindPopup(
                      "<b>Vehicle No : " +
                        c.asrt_nm +
                        "<br>Ending Time : " +
                        this.rteDta[k1].Signal +
                        "</b>"
                    )
                    .addTo(this.routemap);
                }
                // Create traveled route polyline
                this.actl_Polyline = L.polyline(JSON.parse("[" + restr + "]"), {
                  color: "#FF0000",
                  weight: 4,
                  lineCap: "butt",
                  opacity: 0.7,
                  smoothFactor: 1.0,
                  lineJoin: "round",
                  dist: this.trvlDst,
                }).addTo(this.routemap);

                // Fit map bounds to show entire route
                this.routemap.fitBounds(this.actl_Polyline.getBounds());

                // Add distance tooltip
                this.actl_Polyline.bindTooltip(
                  "Traveled Distance: " + this.trvlDst + " Km",
                  {
                    permanent: false,
                    opacity: 0.7,
                    direction: "center",
                  }
                );

                // STEP 4: Add parking markers layer group to map (on top of polyline)
                const markerCount =
                  this._parkingMarkersLayer.getLayers().length;
                console.log(
                  "Attempting to add parking markers layer group. Marker count:",
                  markerCount
                );

                if (markerCount > 0) {
                  // Ensure layer group is properly initialized
                  if (!this._parkingMarkersLayer || !this.routemap) {
                    console.error("Layer group or map not initialized");
                  } else {
                    // Add layer group to map
                    this._parkingMarkersLayer.addTo(this.routemap);

                    // Verify markers are on map
                    const layersOnMap = this._parkingMarkersLayer.getLayers();
                    console.log("✓ Parking markers layer group added to map");
                    console.log(
                      "✓ Layer group contains",
                      layersOnMap.length,
                      "markers"
                    );

                    // Log each marker's position for debugging
                    layersOnMap.forEach((layer: any, idx: number) => {
                      if (layer.getLatLng) {
                        const latlng = layer.getLatLng();
                        console.log(
                          `  Marker P${idx + 1} at [${latlng.lat}, ${
                            latlng.lng
                          }]`
                        );
                      }
                    });

                    // Force map to update
                    setTimeout(() => {
                      this.routemap.invalidateSize();
                      console.log("Map size invalidated to refresh markers");
                    }, 100);
                  }
                } else {
                  console.warn(
                    "⚠ No parking markers to add. Layer group is empty."
                  );
                }
              } else if (res_data.length == 0) {
                this.showLdr = false;
                if (this.actl_Polyline) {
                  this.routemap.removeLayer(this.actl_Polyline);
                }
                if (this.startPBMarker1) {
                  this.routemap.removeLayer(this.startPBMarker1);
                }
                if (this.endPBMarker1) {
                  this.routemap.removeLayer(this.endPBMarker1);
                }
                this.createMessage("warning", "Travelled Route not found!!!!");
              } else {
                this.showLdr = false;
                if (this.actl_Polyline) {
                  this.routemap.removeLayer(this.actl_Polyline);
                }
                if (this.startPBMarker1) {
                  this.routemap.removeLayer(this.startPBMarker1);
                }
                if (this.endPBMarker1) {
                  this.routemap.removeLayer(this.endPBMarker1);
                }
              }
            }
          },
          (err) => {
            // console.log(err);
          }
        );
      } else {
        this.createMessage("warning", "Travelled Route not found!!!!");
      }
    } else {
      if (
        c.rte_arc_lne_tx &&
        c.rte_arc_lne_tx != null &&
        c.rte_arc_lne_tx != undefined
      ) {
        this.allsched_Polyline = L.polyline(JSON.parse(c.rte_arc_lne_tx), {
          color: "#008000",
          weight: 5,
          lineCap: "butt",
          opacity: 0.6,
          smoothFactor: 10.0,
          lineJoin: "round",
        }).addTo(this.routemap);
        this.allSchduleRtes.push(this.allsched_Polyline);
      } else {
        // this.clearRouteMapLayers();
      }
      this.vehTrpLst.forEach((ele) => {
        if (ele.rte_id == c.rte_id && ele.trp_rn_id == c.trp_rn_id) {
          ele.shwEdtBtn = true;
        } else {
          ele.shwEdtBtn = false;
        }
      });
      if (
        c.start_tm != "0000-00-00 00:00:00" &&
        c.end_tm != "0000-00-00 00:00:00"
      ) {
        this.curDate = moment(dt).format("YYYY-MM-DD");
        this.rte_id = c.rte_id;
        this.postslctdDt = {
          dt: this.curDate,
          data: c,
        };
        // Getting travelled route line arc
        console.log("Getting travelled route line arc");
        const rte = `dashboard/enterprise/get_tripTrvlRoute`;
        this.apiServ.post(this.postslctdDt, rte).subscribe(
          (res) => {
            this.showLdr = true;

            if (res["status"] == 200) {
              var res_data = res["data"];
              if (res_data && res_data.length > 0) {
                this.showLdr = false;
                this.rteDta = res["data"];
                // console.log(this.rteDta)
                var restr = "";
                this.rtrstrng = "";
                var arcrestr = "";

                var tmp;
                for (var i = 0; i < this.rteDta.length; i++) {
                  restr +=
                    restr == ""
                      ? "[" +
                        this.rteDta[i].lat +
                        "," +
                        this.rteDta[i].lng +
                        "]"
                      : ",[" +
                        this.rteDta[i].lat +
                        "," +
                        this.rteDta[i].lng +
                        "]";
                  this.rtrstrng = restr;
                  arcrestr +=
                    arcrestr == ""
                      ? this.rteDta[i].lng + " " + this.rteDta[i].lat
                      : "," + this.rteDta[i].lng + " " + this.rteDta[i].lat;
                }

                var lstrng = arcrestr.split("[").join("");
                var lstrng2 = lstrng.split("]").join("");
                this.strngarc = lstrng2;
                // console.log("LINESTRING(" + lstrng2 + ")");

                this.vehTrpLst.forEach((ele) => {
                  if (
                    ele.rte_id == c.rte_id &&
                    this.rtrstrng.length > 0 &&
                    ele.trp_rn_id == c.trp_rn_id
                  ) {
                    ele.shwAddBtn = true;
                    // ele.edtPlybckStrng = '[' + this.rtrstrng + ']';
                    this.showsetRte = true;
                  } else {
                    ele.shwAddBtn = false;
                    this.showsetRte = false;
                  }
                });

                this.alltrvl_Polyline = L.polyline(
                  JSON.parse("[" + restr + "]"),
                  {
                    color: c.clr_obj,
                    weight: 4,
                    lineCap: "butt",
                    opacity: 0.5,
                    smoothFactor: 10.0,
                    lineJoin: "round",
                  }
                ).addTo(this.routemap);

                this.allTrvlRtes.push(this.alltrvl_Polyline);
                // this.routemap.fitBounds(this.actl_Polyline.getBounds());
                // if(this.checked==true){
                this.allTrvlRtes.push(this.alltrvl_Polyline);
                // }

                this.vehTrpLst.forEach((e) => {
                  if (e.rte_id == c.rte_id && e.trp_rn_id == c.trp_rn_id) {
                    console.log(this.slctdSvm);
                    // for ulb having sachivalayam
                    if (this.slctdSvm && this.slctdSvm > 0) {
                      // this.SlctdWrdPolyData.push(e);
                      this.SlctdSvmPolyData.push(e);
                    } else if (this.slctdSvm == 0) {
                    } else {
                      // this.checked = false;
                      this.SlctdSvmPolyData = [];
                      // this.SlctdWrdPolyData = [];
                      if (this.svmplypoint) {
                        for (var k = 0; k < this.svmplypoint.length; k++) {
                          this.routemap.removeLayer(this.svmplypoint[k].ply);
                        }
                      }
                      this.clearRouteMapLayers();
                    }

                    // for ulb having ward data
                    console.log(this.slctdWrd);
                    if (this.slctdWrd && this.slctdWrd > 0) {
                      this.SlctdWrdPolyData.push(c);
                    } else if (this.slctdWrd && this.slctdWrd == 0) {
                    } else {
                      // this.checked = false;
                      this.SlctdWrdPolyData = [];
                      if (this.wrdplypoint && this.wrdplypoint.length > 0) {
                        for (var k = 0; k < this.wrdplypoint.length; k++) {
                          this.routemap.removeLayer(this.wrdplypoint[k].ply);
                        }
                      }
                      this.clearRouteMapLayers();
                    }
                  }
                });
              } else if (res_data.length == 0) {
                this.showLdr = false;

                this.createMessage("warning", "Travelled Route not found!!!!");
              } else {
                this.showLdr = false;
                if (this.actl_Polyline) {
                  this.routemap.removeLayer(this.actl_Polyline);
                }

                // this.createMessage('warning', 'No data found!!!!');
              }
            }
          },
          (err) => {
            this.showLdr = false;
            console.log(err);
          }
        );
      } else {
        this.showLdr = false;
        this.createMessage("warning", "Travelled Route not found!!!!");
      }
    }
  }

  getTripLocations() {
    var resData = [];
    let rte = `dashboard/enterprise/getTripLctns`;
    this.apiServ.get(rte).subscribe((res) => {
      if (res["status"] == 200) {
        resData = res["data"];
        // console.log(resData)
        for (var i = 0; i <= resData.length; i++) {
          if (resData[i] != undefined) {
            if (resData[i].fnc_ky == 1) {
              this.tripLoctns.push({
                strt_fnce_id: resData[i].fnce_id,
                strt_fnce_nm: resData[i].fnce_nm,
              });
            } else {
              this.tripEndLoctns.push({
                end_fnce_id: resData[i].fnce_id,
                end_fnce_nm: resData[i].fnce_nm,
              });
            }
          }
        }
      }
    });
  }
  createMessage(type: string, msg: string): void {
    this.message.create(type, msg);
  }
  setMasterRoute() {
    this.modal.confirm({
      nzTitle: "<i>Do you Want to Save this Route?</i>",
      nzOnOk: () => this.addRoute(),
    });
  }
  addRoute() {
    var postData = {
      dt: this.curDate,
      rte_id: this.rte_id,
      rte_nm: this.rte_nm,
      rte: "[" + this.rtrstrng + "]",
      tnt_id: this.selectedtenant,
      trp_sqnc_nu: this.trp_sqnc_nu,
      rte_ln: "LINESTRING(" + this.strngarc + ")",
      trp_schde_id: this.trp_schde_id,
      rte_plyln_id: this.rte_plyln_id,
      asrt_id: this.asrt_id,
    };
    console.log(postData);
    if (this.rtrstrng != undefined) {
      const rte1 = `dashboard/enterprise/addPolylne`;
      this.apiServ.post(postData, rte1).subscribe((res) => {
        if (res["status"] == 200) {
          // this.createMessage('success', 'Schedule Route added Successfully and New route will reflect from tomorrow');
          this.createMessage("success", "Schedule Route added Successfully");

          this.selectCategory(0, this.curDate);
        }
      });
    }
  }
  getCvrdFncs(c) {
    console.log(c);
    if (this.ipPts) {
      for (var x = 0; x < this.ipPts.length; x++) {
        this.routemap.removeLayer(this.ipPts[x]);
      }
    }
    if (this.cvrdIps) {
      for (var y = 0; y < this.cvrdIps.length; y++) {
        this.routemap.removeLayer(this.cvrdIps[y]);
      }
    }

    var postData = {
      asrt_id: c.asrt_id,
      rte_id: c.rte_id,
      tnt_id: this.selectedtenant,
      strt_tm: c.start_tm,
      end_tm: c.end_tm,
    };
    const rte = `tripschedule/sachivalayam/trips/get_cvrd_fncs`;
    this.apiServ.post(postData, rte).subscribe((res) => {
      if (res["status"] == 200) {
        this.fncDtls = res["data"];
        if (this.fncDtls.length > 0) {
          for (var i = 0; i < this.fncDtls.length; i++) {
            if (this.fncDtls[i].lat && this.fncDtls[i].lng) {
              if (this.fncDtls[i].fnce_cvr_sts == 1) {
                this.ipMarker = L.circleMarker(
                  [this.fncDtls[i].lat, this.fncDtls[i].lng],
                  {
                    radius: 6,
                    fillColor: "#008000",
                    color: "#008000",
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 1,
                  }
                )
                  .addTo(this.routemap)
                  .bindTooltip(this.fncDtls[i].fnce_nm, {
                    permanent: false,
                    opacity: 0.7,
                  })
                  .openTooltip();

                this.ipPts.push(this.ipMarker);
              } else {
                this.ipMarker1 = L.circleMarker(
                  [this.fncDtls[i].lat, this.fncDtls[i].lng],
                  {
                    radius: 6,
                    fillColor: "#e85339",
                    color: "#e85339",
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 1,
                  }
                )
                  .addTo(this.routemap)
                  .bindTooltip(this.fncDtls[i].fnce_nm, {
                    permanent: false,
                    opacity: 0.7,
                  })
                  .openTooltip();

                this.cvrdIps.push(this.ipMarker1);
              }
            }
          }
        } else {
          if (this.ipPts) {
            for (var x = 0; x < this.ipPts.length; x++) {
              this.routemap.removeLayer(this.ipPts[x]);
            }
          }
          if (this.cvrdIps) {
            for (var y = 0; y < this.cvrdIps.length; y++) {
              this.routemap.removeLayer(this.cvrdIps[y]);
            }
          }
        }
      }
    });
  }
  getsort(id, type) {
    this.selectedSortId = id;
    this.selectedSortType = type;
    this.rdchked = false;
    this.shwRdCks = type == "rd";
    this.currentPage = 1;
    this.loadTrips();
  }
  rdChkd(evt) {
    this.rdchked = evt;
    this.currentPage = 1;
    this.loadTrips();
  }
  getVendors() {
    // console.log(this.userDtls.dsgns_id)
    if (this.userDtls.dsgns_id == 1000032) {
      this.selectedvndr = this.userDtls.vndr_id;
      this.showVndr = true;
      if (this.selectedvndr && this.showVndr) {
        this.apiServ
          .get(`billing/vendors/list/${this.selectedvndr}/byId`)
          .subscribe(
            (res) => {
              // console.log(res)
              if (res["status"] == 200) {
                this.vendorList = res["data"];
                this.selectedvndr = this.vendorList[0].vndr_id;
                this.selectCategory(0, this.curDate);
                this.get_rtDvtdTrips(this.curDate);
              }
            },
            (err) => {
              // console.log("In errorr");
            }
          );
      }
    } else if (this.clap_in == 0 || this.clap_in == 2) {
      this.vendorList = [];
      this.selectedvndr = 0;
      this.selectCategory(0, this.curDate);
      this.get_rtDvtdTrips(this.curDate);
    } else {
      this.apiServ
        .get(`billing/vehicle-wise/vendors/list/${this.selectedtenant}`)
        .subscribe(
          (res) => {
            if (res["status"] === 200) {
              this.vendorList = res["data"];
              this.selectedvndr = this.vendorList[0].vndr_id;
              // if (this.vendorList.length > 1) {
              //   // this.selectedvndr = 0;
              //   this.selectedvndr=this.vendorList[0].vndr_id;// added this for jaipur client data load
              // } else {
              //   this.selectedvndr = this.vendorList[0].vndr_id;
              // }
              this.selectCategory(0, this.curDate);
              this.get_rtDvtdTrips(this.curDate);
            }
          },
          (err) => {
            // // console.log('In errorr
          }
        );
    }
  }
  onvndrSelect(value) {
    this.selectedvndr = value;
    this.selectCategory(0, this.curDate);
    this.get_rtDvtdTrips(this.curDate);
  }
  getWrdbyAsrt(asrt_id) {
    if (this.wrdplypoint) {
      for (var k = 0; k < this.wrdplypoint.length; k++) {
        this.routemap.removeLayer(this.wrdplypoint[k].ply);
      }
    }
    this.apiServ.get(`playback/wards/byVhcle/${asrt_id}`).subscribe(
      (res) => {
        if (res["status"] === 200) {
          this.wardLst = res["data"];
          // console.log(this.wardLst)
          if (this.wardLst.length > 0) {
            for (var l = 0; l < this.wardLst.length; l++) {
              if (this.wardLst[l].fnce_arc_lne_tx) {
                this.wrdfncepolygon = L.polygon(
                  JSON.parse(this.wardLst[l].fnce_arc_lne_tx) as [],
                  { color: this.wardLst[l].fncs_clr_cd }
                )
                  .addTo(this.routemap)
                  .bindTooltip(this.wardLst[l].wrd_nm, {
                    permanent: true,
                    opacity: 0.7,
                  })
                  .openTooltip();
                this.wrdplypoint.push({
                  ply: this.wrdfncepolygon,
                  fnce_id: this.wardLst[l].fnce_id,
                });
                this.routemap.fitBounds(this.wrdfncepolygon.getBounds());
              }
            }
          }
        }
      },
      (err) => {
        console.log("In errorr");
      }
    );
  }

  clearRouteMapLayers() {
    this.SlctdWrdPolyData = [];
    // this.SlctdSvmPolyData=[];
    // Guard: skip if map is not yet initialized (e.g. during ngOnInit before ngAfterViewInit)
    if (!this.routemap || typeof this.routemap.removeLayer !== "function") {
      return;
    }
    if (this.ipPts) {
      for (var x = 0; x < this.ipPts.length; x++) {
        this.routemap.removeLayer(this.ipPts[x]);
      }
    }
    if (this.cvrdIps) {
      for (var y = 0; y < this.cvrdIps.length; y++) {
        this.routemap.removeLayer(this.cvrdIps[y]);
      }
    }
    if (this.allSchduleRtes) {
      for (var x = 0; x < this.allSchduleRtes.length; x++) {
        this.routemap.removeLayer(this.allSchduleRtes[x]);
      }
    }
    if (this.allTrvlRtes) {
      for (var x = 0; x < this.allTrvlRtes.length; x++) {
        this.routemap.removeLayer(this.allTrvlRtes[x]);
      }
    }
    if (this.edtPolyline) {
      this.map.removeLayer(this.edtPolyline);
    }
    if (this.actl_Polyline) {
      this.routemap.removeLayer(this.actl_Polyline);
    }
    if (this.startPBMarker1) {
      this.routemap.removeLayer(this.startPBMarker1);
    }
    if (this.endPBMarker1) {
      this.routemap.removeLayer(this.endPBMarker1);
    }

    if (this.schdStartPBMarker) {
      this.routemap.removeLayer(this.schdStartPBMarker);
    }
    if (this.schdStartMarker) {
      this.routemap.removeLayer(this.schdStartMarker);
    }

    if (this.schdEndMarker) {
      this.routemap.removeLayer(this.schdEndMarker);
    }
    if (this.schdEndPBMarker) {
      this.routemap.removeLayer(this.schdEndPBMarker);
    }
    if (this.route_Polyline != undefined) {
      this.routemap.removeLayer(this.route_Polyline);
    }

    // Clear parking markers layer group
    if (this._parkingMarkersLayer) {
      this._parkingMarkersLayer.clearLayers();
      this.routemap.removeLayer(this._parkingMarkersLayer);
    }
    if (this.parkingMarkerGroups) {
      this.parkingMarkerGroups.forEach((group) => {
        group?.legs?.forEach((leg) => this.routemap.removeLayer(leg));
      });
      this.parkingMarkerGroups.clear();
    }
    this.finalSpdMrkrs = [];
  }

  onInput(ev: any) {
    this.searchText = ev;
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }
    this.searchDebounceTimer = setTimeout(() => {
      this.currentPage = 1;
      this.loadTrips();
    }, 400);
  }

  deSelectChk(evt) {
    console.log(evt);
    if (evt == false) {
      this.clearRouteMapLayers();
    } else {
    }
  }
  onselectStrtLctn(strtLoc) {
    this.strt_loc = strtLoc;
    this.selectCategory(0, this.curDate);
  }
  onselectEndLctn(endLoc) {
    this.end_loc = endLoc;
    this.selectCategory(0, this.curDate);
  }
  editRoute(c, val) {
    console.log(c);
    this.map_stng.show_grid = false;
    this.map_stng.show_sidebar = false;
    this.svmChkd = false;

    // Ensure geometry is loaded before opening editor
    if (!c.rte_arc_lne_tx && c.has_rte_plyln == 1) {
      this.apiServ
        .post(
          { trp_schde_id: c.trp_schde_id },
          "dashboard/enterprise/get_vehTripGeom"
        )
        .subscribe((geomRes) => {
          if (geomRes && geomRes["data"] && geomRes["data"].length > 0) {
            c.rte_arc_lne_tx = geomRes["data"][0].rte_arc_lne_tx;
            c.strt_fnce_bnd = geomRes["data"][0].strt_fnce_bnd;
            c.end_fnce_bnd = geomRes["data"][0].end_fnce_bnd;
          }
          this._openRouteEditor(c, val);
        });
    } else {
      this._openRouteEditor(c, val);
    }
  }

  _openRouteEditor(c, val) {
    this.isVisible = true;
    this.rteSaveData = c;
    this.Pbstrt_tm = new Date(this.rteSaveData.start_tm);
    this.Pbend_tm = new Date(this.rteSaveData.end_tm);

    console.log(val);
    if (val == "edt") {
      this.rteSaveData.isEdit = true;
    } else {
      this.rteSaveData.isEdit = false;
    }
    this.chklyrSlct(this.tileLayers[0]);
  }
  handleCancel(): void {
    console.log("Button cancel clicked!");
    this.isVisible = false;
    this.svmChkd = false;
  }

  onSvmChk(evt) {
    this.svmChkd = evt;
    if (
      this.rteSaveData.svm_id &&
      this.selectedtenant == 1000033 &&
      this.svmChkd == true
    ) {
      this.plotSvmBndsInMapWndw(this.rteSaveData.svm_id);
    } else if (this.svmChkd != true) {
      if (this.svmplypoint2) {
        for (var k = 0; k < this.svmplypoint2.length; k++) {
          this.map.removeLayer(this.svmplypoint2[k].ply);
        }
      }
    }
  }

  drawnItems: FeatureGroup = featureGroup();
  drawOptions = {
    position: "topright",
    draw: {
      polyline: {
        shapeOptions: {
          color: "red",
          weight: 2,
        },
      },
    },
    edit: {
      featureGroup: this.drawnItems,
      // remove: false
    },
  };

  controldata: any;
  onMapReady(map: any) {
    // Make Leaflet globally available for easyprint
    (window as any).L = L;

    // Dynamically load leaflet-easyprint after L is global
    if (!L.hasOwnProperty("easyPrint")) {
      import("leaflet-easyprint")
        .then(() => {
          console.log("leaflet-easyprint loaded dynamically");
        })
        .catch((err) => {
          console.error("Failed to load leaflet-easyprint:", err);
        });
    }

    // console.log("onMapReady",this.edtPolyline);
    // console.log("onMapReady",map);
    // console.log("onMapReady",this.drawnItems);
    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }

    this.map = [];
    this.map = map;
    // this.pointMap();
    this.that = this;
    const that: any = this;
    const tiles = L.tileLayer(
      "http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
      {
        maxZoom: 24,
        minZoom: 3,
        subdomains: ["mt0", "mt1", "mt2", "mt3"],
        attribution: "",
      }
    );
    tiles.addTo(this.map);
    // console.log(this.clntDtls)
    this.map.setView([this.clntDtls[0].lat, this.clntDtls[0].lng], 13);
    // console.log(this.rteSaveData)
    // **************** for Route Edit *****************************//
    if (this.edtPolyline) {
      // console.log(this.edtPolyline)
      this.map.removeLayer(this.edtPolyline);
      this.drawnItems.removeLayer(this.edtPolyline);
    }
    if (this.rteSaveData.isEdit == true) {
      if (this.strtMrkr) {
        this.map.removeLayer(this.strtMrkr);
      }
      if (this.endMrkr) {
        this.map.removeLayer(this.endMrkr);
      }
      if (this.edtPolyline) {
        // console.log(this.edtPolyline)
        this.map.removeLayer(this.edtPolyline);
        this.drawnItems.removeLayer(this.edtPolyline);
      }
      // console.log(this.rteSaveData.edtPlybckStrng,'editable palback stringgggggggggggggggg')
      this.edtPolyline = L.polyline(
        JSON.parse(this.rteSaveData.rte_arc_lne_tx),
        {
          color: "#008000",
          weight: 5,
          lineCap: "butt",
          opacity: 0.6,
          smoothFactor: 10.0,
          lineJoin: "round",
        }
      ).addTo(this.map);

      this.map.fitBounds(this.edtPolyline.getBounds());

      this.drawnItems.addLayer(this.edtPolyline);
      this.drawnItems.addTo(this.map);
      var linemarker = JSON.parse(this.rteSaveData.rte_arc_lne_tx);
      console.log(linemarker[0]);
      this.schdStartPBMarker = L.marker(linemarker[0], {
        icon: this.startIcon,
      }).addTo(this.map); // this.editPlylneList.push(this.edtPolyline);

      this.schdEndPBMarker = L.marker(linemarker[linemarker.length - 1], {
        icon: this.endIcon,
      }).addTo(this.map);

      if (this._strtFncBndLayer) {
        this._strtFncBndLayer.clearLayers();
      }
      if (this._endFncBndLayer) {
        this._endFncBndLayer.clearLayers();
      }
      if (
        this.rteSaveData.strt_fnce_bnd &&
        this.rteSaveData.strt_fnce_bnd != null
      ) {
        this.strtFnceBnd = L.polygon(
          JSON.parse(this.rteSaveData.strt_fnce_bnd),
          {
            color: "#0f2e5c",
            weight: 2,
            lineCap: "butt",
            opacity: 0.6,
            smoothFactor: 10.0,
            lineJoin: "round",
          }
        ).addTo(this._strtFncBndLayer);
        this._strtFncBndLayer.addTo(this.map);
      }
      if (
        this.rteSaveData.end_fnce_bnd &&
        this.rteSaveData.end_fnce_bnd != null
      ) {
        this.endFnceBnd = L.polygon(JSON.parse(this.rteSaveData.end_fnce_bnd), {
          color: "#0f2e5c",
          weight: 2,
          lineCap: "butt",
          opacity: 0.6,
          smoothFactor: 10.0,
          lineJoin: "round",
        }).addTo(this._endFncBndLayer);
        this._endFncBndLayer.addTo(this.map);
      }
    } else {
      if (this.strtMrkr) {
        this.map.removeLayer(this.strtMrkr);
      }
      if (this.endMrkr) {
        this.map.removeLayer(this.endMrkr);
      }
      // ----------Fence Start Area (flag position) -- Leaflet OS ----------//
      if (this.rteSaveData.strt_fnce_lat && this.rteSaveData.strt_fnce_lng) {
        this.strtMrkr = L.marker(
          [this.rteSaveData.strt_fnce_lat, this.rteSaveData.strt_fnce_lng],
          {
            icon: this.startIcon1,
          }
        ).addTo(this.map);
      }
      // ----------Fence END Area (flag position) -- Leaflet OS ----------//
      if (this.rteSaveData.end_fnce_lat && this.rteSaveData.end_fnce_lng) {
        this.endMrkr = L.marker(
          [this.rteSaveData.end_fnce_lat, this.rteSaveData.end_fnce_lng],
          {
            icon: this.endIcon1,
          }
        ).addTo(this.map);
      }
    }

    // **************** for Route Edit - Using Leaflet Draw (not Geoman) *****************************//
    map.on("draw:editvertex", function (event) {
      this.poly = event.poly._latlngs;
      // console.log(this.poly)
    });

    // Note: We use Leaflet Draw, not Leaflet Geoman (pm), so no pm.addControls()
    this.map.on(L.Draw.Event.CREATED, function (e) {
      // console.log("Map draw event -------- " + e.layerType);
      Object.keys(e.layer._latlngs).forEach((key) => {
        console.log(key, "Lat", e.layer._latlngs[key].lat);
        console.log(key, "Lng", e.layer._latlngs[key].lng);
      });

      that.edit_fence.fnce_type = "Polyline";
      that.edit_fence.crtd_fnce_type = that.edit_fence.fnce_type;
      that.edit_fence.fnce_type = "";
      const layer: any = (e as DrawEvents.Created).layer;
      this.editablLayers.addLayer(layer);
      console.log("layer.layer  :: ");
      console.log(JSON.parse(layer));
      this.addedNwLAyer = this.drawnItems.addLayer(layer);
    });

    this.showCoordinates();

    L.control
      .ruler({
        lengthUnit: {
          // You can use custom length units. Default unit is kilometers.
          display: "km", // This is the display value will be shown on the screen. Example: 'meters'
          decimal: 4, // Distance result will be fixed to this value.
          factor: null, // This value will be used to convert from kilometers. Example: 1000 (from kilometers to meters)
          label: "Distance:",
        },
        angleUnit: {
          display: "&deg;", // This is the display value will be shown on the screen. Example: 'Gradian'
          decimal: 2, // Bearing result will be fixed to this value.
          factor: null, // This option is required to customize angle unit. Specify solid angle value for angle unit. Example: 400 (for gradian).
          label: "Bearing:",
        },
      })
      .addTo(this.map);

    // Initialize print button with proper error handling
    if (this.printbtn) {
      try {
        this.map.removeControl(this.printbtn);
        this.printbtn = null;
      } catch (e) {
        console.log("Error removing print control:", e);
      }
    }

    // Wait for map to be fully initialized
    setTimeout(() => {
      try {
        // Check if leaflet-easyprint is loaded
        const leafletEasyPrint =
          (window as any).L?.easyPrint || (L as any).easyPrint;

        if (leafletEasyPrint) {
          this.printbtn = leafletEasyPrint({
            title: "Export Map",
            position: "bottomleft",
            filename: "TRACK_MAP",
            exportOnly: true,
            hideControlContainer: true,
            sizeModes: ["Current", "A4Portrait", "A4Landscape"],
            tileWait: 1000,
            hideClasses: [
              "leaflet-control-zoom",
              "leaflet-control-attribution",
            ],
          }).addTo(this.map);
          console.log("Print button initialized successfully");
        } else {
          console.error(
            "leaflet-easyprint not loaded. Please ensure bundle.js is included in angular.json scripts."
          );
          this.message.error(
            "Map print feature not available. Please reload the page."
          );
        }
      } catch (e) {
        console.error("Error initializing print button:", e);
        this.message.warning("Map print feature initialization failed.");
      }
    }, 1000);
  }

  showCoordinates() {
    const Coordinates = L.Control.extend({
      onAdd: (map) => {
        const container = L.DomUtil.create("div");
        map.addEventListener("mousemove", (e) => {
          container.innerHTML = `<h6> Latitude  ${e.latlng.lat.toFixed(
            6
          )} <br>Longitude  ${e.latlng.lng.toFixed(6)} </h6>`;
        });
        return container;
      },
    });
    this.map.addControl(new Coordinates({ position: "topleft" }));
  }

  deleteLastVertex() {
    // L.Draw.Polyline.deleteLastVertex()
    console.log("In deleteLastVertex ======>>>");
    if (
      this.edit_fence.fnce_nm === "Polyline" ||
      this.edit_fence.fnce_nm === "Polygon"
    ) {
      this.fnce_drawer.polylineDrawer.deleteLastVertex();
    }
  }
  saveFence() {
    console.log("In saveFence ====> creating fence ");
    console.log(this.edit_fence);

    this.clearFence();
  }
  clearFence() {
    console.log("In clearFence ===> clear fence ");
    this.edit_fence = {
      fnce_type: "",
      crtd_fnce_type: "",
      fnce_nm: "",
      dscn_tx: "",
      imge_url_tx: "",
      Opacity: "30",
      FillOpacity: "30",
      stroke: 2,
      weight: 2,
      dashArray: "2,2",
      color: "#8c90f2",
      fill: true,
      fillColor: "#8c90f2",
      stroke_type: "DIRECTED_ROUTE",
      marker_id: 1,
      marker_nm: "RED_MARKER",
      marker_icn_url: "007-placeholder.svg",
      lat: null,
      lng: null,
      latlng_array: [],
      radius: null,
    };
  }

  public onDrawCreated(e: any) {
    // console.log(e.layer);
    // console.log(e.layer.options.color);
    // console.log(e.layer.options.clickable);
    // console.log(e.layer.options.fill);
    // console.log(e.layer.options.opacity);
    // console.log(e.layer.options.stroke);
    // console.log(e.layer.options.weight);

    // console.log(e.layer._latlngs)
    // console.log(e.layer._latlngs.lat);
    // console.log(e.layer._latlngs.lat);
    var restr = "";
    this.rtrstrng = "";
    var arcrestr = "";

    var latLngData = e.layer._latlngs;
    for (var i = 0; i < latLngData.length; i++) {
      restr +=
        restr == ""
          ? "[" + latLngData[i].lat + "," + latLngData[i].lng + "]"
          : ",[" + latLngData[i].lat + "," + latLngData[i].lng + "]";
      this.rtrstrng = restr;
      arcrestr +=
        arcrestr == ""
          ? latLngData[i].lng + " " + latLngData[i].lat
          : "," + latLngData[i].lng + " " + latLngData[i].lat;
    }

    var lstrng = arcrestr.split("[").join("");
    var lstrng2 = lstrng.split("]").join("");
    this.strngarc = lstrng2;

    console.log("onDrawCreated =====> Draw Created Event!");
    Object.keys(e.layer._latlngs).forEach((key) => {
      console.log(key, "CREATED==>Lat", e.layer._latlngs[key].lat);
      console.log(key, "CREATED==>Lng", e.layer._latlngs[key].lng);
    });
    // console.log(e)

    const layer = (e as DrawEvents.Created).layer;
    this.drawnItems.addLayer(layer);
    this.saveRouteAlert(this.strngarc, this.rtrstrng);
  }
  saveRouteAlert(strngarc, rtrstrng) {
    var data = {
      strngarc: strngarc,
      rtrstrng: rtrstrng,
    };
    this.modal.confirm({
      nzTitle: "<i>Do you Want to Save this Route?</i>",
      nzOnOk: () => this.addnwRoute(data),
    });
  }
  addnwRoute(plyData) {
    var postData = {
      dt: moment(this.slctdDt).format("YYYY-MM-DD"),
      rte_id: this.rteSaveData.rte_id,
      rte_nm: this.rteSaveData.rte_nm,
      rte: "[" + plyData.rtrstrng + "]",
      tnt_id: this.selectedtenant,
      trp_sqnc_nu: this.rteSaveData.trp_sqnc_nu,
      rte_ln: "LINESTRING(" + plyData.strngarc + ")",
      trp_schde_id: this.rteSaveData.trp_schde_id,
      rte_plyln_id: this.rteSaveData.rte_plyln_id,
      asrt_id: this.rteSaveData.asrt_id,
    };
    // console.log(postData)
    if (this.rtrstrng != undefined) {
      const rte1 = `dashboard/enterprise/addPolylne`;
      this.apiServ.post(postData, rte1).subscribe((res) => {
        if (res["status"] == 200) {
          this.createMessage(
            "success",
            "Schedule Route added Successfully and New route will reflect from tomorrow"
          );
          this.selectCategory(0, this.curDate);
        }
      });
    }
  }
  public onDrawEditStop(e: any) {
    // console.log("edit stopppp")
    // console.log(e);
    var restr = "";
    this.rtrstrng = "";
    var arcrestr = "";
    var latLngData = e.target.poly;
    for (var i = 0; i < latLngData.length; i++) {
      // console.log(latLngData[0]);

      restr +=
        restr == ""
          ? "[" + latLngData[i].lat + "," + latLngData[i].lng + "]"
          : ",[" + latLngData[i].lat + "," + latLngData[i].lng + "]";
      this.rtrstrngEdt = restr;
      arcrestr +=
        arcrestr == ""
          ? latLngData[i].lng + " " + latLngData[i].lat
          : "," + latLngData[i].lng + " " + latLngData[i].lat;
    }

    var lstrng = arcrestr.split("[").join("");
    var lstrng2 = lstrng.split("]").join("");
    this.strngarcEdt = lstrng2;
    this.saveRouteAlert(this.strngarcEdt, this.rtrstrngEdt);
  }
  public onDrawStart(e: any) {
    console.log(e);
    console.log(e.layer);
    console.log("onDrawStart ======> Draw Started Event!");
    this.edit_fence.lat = null;
    this.edit_fence.lng = null;
    this.edit_fence.latlng_array = [];
    this.map_stng.undo_flag = true;
  }

  enablePolyline() {
    console.log("enablePolyline ======>  In enablePolyline");
    this.fnce_drawer.polylineDrawer = new L.Draw.Polyline(this.map, {
      shapeOptions: {
        color: this.edit_fence.color,
        opacity: Math.round(this.edit_fence.opacity / 100),
        stroke: this.edit_fence.stroke,
        dashArray: this.edit_fence.dashArray,
        fill: false,
        //  ,weight: this.edit_fence.stroke
      },
    });
    this.fnce_drawer.polylineDrawer.enable();
  }
  addPolyline(p_latlngs: any, p_optns: any, p_route_path: any) {
    console.log(p_latlngs);
    const optns: any = {
      color: "black",
      fill: false,
      fillColor: "green",
      fillOpacity: 0.5,
      opacity: 1,
      stroke: 2,
      weight: 2,
      dashArray: "2,2",
    };

    if (!(p_optns.color === undefined)) {
      optns.color = p_optns.color;
    }
    if (!(p_optns.fill === undefined)) {
      optns.fill = p_optns.fill;
    }
    if (!(p_optns.fillColor === undefined)) {
      optns.fillColor = p_optns.fillColor;
    }
    if (!(p_optns.fillOpacity === undefined)) {
      optns.fillOpacity = p_optns.fillOpacity / 100;
    }
    if (!(p_optns.opacity === undefined)) {
      optns.opacity = p_optns.opacity / 100;
    }
    if (!(p_optns.stroke === undefined)) {
      optns.stroke = p_optns.stroke;
    }
    if (!(p_optns.weight === undefined)) {
      optns.weight = p_optns.weight;
    }
    if (!(p_optns.dashArray === undefined)) {
      optns.dashArray = p_optns.dashArray;
    }

    const latlngs: [number, number][] = p_latlngs;
    const l_ploly: any = L.polyline(latlngs, optns);

    // Direction in red
    if (p_route_path === "DIRECTED_ROUTE") {
      l_ploly.setText("  \u25BA  ", {
        repeat: true,
        offset: 3,
        attributes: { fill: "red" },
      });
    }
    // Railway track
    if (p_route_path === "RAILWAY_TRACK") {
      optns.weight = 10;
      optns.color = "grey";
      l_ploly.setText("| ", {
        repeat: true,
        offset: 3,
        attributes: { fill: "black", "font-weight": "bold", "font-size": "10" },
      });
    }

    this.drawnItems.addLayer(l_ploly);
  }
  clearEditablePolyline() {
    if (this.edtPolyline) {
      console.log(this.edtPolyline);
      this.map.removeLayer(this.edtPolyline);
      this.drawnItems.removeLayer(this.edtPolyline);
    }
    if (this.drawnItems) {
      this.drawnItems.clearLayers();
    }

    // if (this.schdStartPBMarker) {
    //   this.map.removeLayer(this.schdStartPBMarker);
    // }
    // if (this.schdEndPBMarker) {
    //   this.map.removeLayer(this.schdEndPBMarker);
    // }
  }
  // Route  Deviation slider

  deviateSlider(c) {
    this.openSlider = true;
    this.slctdDtls = c;
  }
  closeSideBar() {
    this.openSlider = false;
    this.dvtnForm.reset();
  }
  addDvtnRsn() {
    if (this.isSavingRsn) {
      return;
    }
    if (!this.perms.canWrite()) {
      this.createMessage(
        "Error",
        "You do not have permission to submit deviation reasons."
      );
      return;
    }
    var postData = {
      trp_rn_id: this.slctdDtls.trp_rn_id,
      trvl_dt: this.slctdDtls.sch_strt_dt,
      drvr_cntctd_in: this.dvtnForm.value.drvr_cntctd_in,
      rte_dvtn_acpt_in: this.dvtnForm.value.rte_dvtn_acpt_in,
      dvtn_rsn_tx: this.dvtnForm.value.dvtn_rsn_tx,
      tnt_id: this.selectedtenant,
    };
    this.isSavingRsn = true;
    this.apiServ
      .post(postData, `dashboard/enterprise/route-deviation/reason`)
      .subscribe(
        (res) => {
          this.isSavingRsn = false;
          if (res["status"] == 200) {
            this.createMessage(
              "Success",
              "Route Deviation Reason added successfully"
            );
            this.openSlider = false;
            this.selectCategory(0, this.curDate);
          } else {
            this.createMessage("Warning", "Please Try Again");
          }
        },
        () => {
          this.isSavingRsn = false;
        }
      );
  }
  onselectPbStrtTime(dt) {
    this.Pbstrt_tm = new Date(dt);
    this.chckHrsDiff(this.Pbstrt_tm, this.Pbend_tm);
  }
  onselectPbEndTime(dt) {
    this.Pbend_tm = new Date(dt);
    this.chckHrsDiff(this.Pbstrt_tm, this.Pbend_tm);
  }
  chckHrsDiff(strt, end) {
    // Calculate the time difference in milliseconds
    const timeDiff = Math.abs(end - strt);
    // Convert milliseconds to hours
    this.hoursDiff = Math.floor(timeDiff / (1000 * 60 * 60));
  }
  getPlayBack() {
    this.chckHrsDiff(this.Pbstrt_tm, this.Pbend_tm);

    var postslctdDt = {
      data: {
        dev_imei_nu: this.rteSaveData.dev_imei_nu,
        start_tm: this.datepipe.transform(this.Pbstrt_tm, "yyyy-MM-dd HH:mm"),
        end_tm: this.datepipe.transform(this.Pbend_tm, "yyyy-MM-dd HH:mm"),
      },
    };

    if (this.hoursDiff <= 8) {
      // Getting travelled route line arc
      const rte = `dashboard/enterprise/get_tripTrvlRoute`;
      this.apiServ.post(postslctdDt, rte).subscribe((res) => {
        console.log(res);
        var restr = "";
        this.pbRtData = res["data"];
        for (let i = 0; i < this.pbRtData.length; i++) {
          restr +=
            restr == ""
              ? "[" + this.pbRtData[i].lat + "," + this.pbRtData[i].lng + "]"
              : ",[" + this.pbRtData[i].lat + "," + this.pbRtData[i].lng + "]";
        }
        if (this.PlyBk_Polyline) {
          this.map.removeLayer(this.PlyBk_Polyline);
        }
        if (this.startPBMarker) {
          this.map.removeLayer(this.startPBMarker);
        }
        if (this.endPBMarker) {
          this.map.removeLayer(this.endPBMarker);
        }
        // ----------Fence Start Area (flag position) -- Leaflet OS ----------//
        this.startPBMarker = L.marker(
          [this.pbRtData[0].lat, this.pbRtData[0].lng],
          {
            icon: this.startIcon1,
          }
        ).addTo(this.map);

        // ----------Fence END Area (flag position) -- Leaflet OS ----------//
        let k1 = this.pbRtData.length - 1;
        this.endPBMarker = L.marker(this.pbRtData[k1], {
          icon: this.endIcon1,
        }).addTo(this.map);

        this.PlyBk_Polyline = L.polyline(JSON.parse("[" + restr + "]"), {
          color: "#b157e9",
          weight: 4,
          lineCap: "butt",
          opacity: 0.5,
          smoothFactor: 10.0,
          lineJoin: "round",
          dist: this.trvlDst,
        }).addTo(this.map);
        this.map.fitBounds(this.PlyBk_Polyline.getBounds());
      });
    } else {
      this.createMessage(
        "warning",
        "Please select the playback time with 8 hours Difference"
      );
    }
  }

  onStrtTmEdt(s) {
    let sch_strt_tm = s.sch_strt_tm ? s.sch_strt_tm : "00:00:00";
    this.slctdstrt_tm =
      "Wed Jun 21 2023 " + sch_strt_tm + " GMT+0530 (India Standard Time)";
    this.vehTrpLst.forEach((ele) => {
      if (ele.trp_schde_id != s.trp_schde_id) {
        ele.shwStrtTmEdt = false;
      } else {
        ele.shwStrtTmEdt = true;
      }
    });
  }
  onselectStrtTime(tm, s) {
    this.slctdstrt_tm = moment(tm, ["h:mm A"]).format("HH:mm");
    var data = {
      trp_schde_id: s.trp_schde_id,
      schdle_strt_tm: this.slctdstrt_tm,
      key: "strTm",
    };
    this.updateCnfrmMdl("Start Time", data);
  }
  onEndTmEdt(s) {
    let sch_end_tm = s.sch_end_tm ? s.sch_end_tm : "00:00:00";
    this.slctdend_tm =
      "Wed Jun 21 2023 " + sch_end_tm + " GMT+0530 (India Standard Time)";
    this.vehTrpLst.forEach((ele) => {
      if (ele.trp_schde_id != s.trp_schde_id) {
        ele.shwEndTmEdt = false;
      } else {
        ele.shwEndTmEdt = true;
      }
    });
  }
  onselectEndTime(tm, s) {
    this.slctdend_tm = moment(tm, ["h:mm A"]).format("HH:mm");
    var data = {
      trp_schde_id: s.trp_schde_id,
      schdle_end_tm: this.slctdend_tm,
      key: "endTm",
    };
    this.updateCnfrmMdl("End Time", data);
  }
  updateCnfrmMdl(ele, data) {
    this.modal.confirm({
      nzTitle: `Are you sure Do You Want To Change ${ele}?`,
      nzOkText: "Yes",
      nzOkType: "primary",
      nzOnOk: () => {
        this.showLdr = true;
        this.apiServ
          .post(data, `tripschedule/trips/schedule/trips/chngeVehcle`)
          .subscribe((res) => {
            if (res["status"] == 200) {
              this.showLdr = false;
              this.createMessage("Success", `${ele} successfully Updated`);
              this.selectCategory(0, this.curDate);
            }
          });
      },
      nzCancelText: "No",
      nzOnCancel: () => {
        this.closeSlct(data);
      },
    });
  }
  closeSlct(s) {
    this.vehTrpLst.forEach((ele) => {
      if (ele.trp_schde_id == s.trp_schde_id) {
        ele.shwEndTmEdt = false;
        ele.shwStrtTmEdt = false;
      }
    });
  }
  openOprtsSldr(c) {
    this.oprtnsData = c;
    this.onStrtTmEdt(c);
    this.onEndTmEdt(c);
    this.openOprtnSlider = true;
    // console.log(this.oprtnsData);
  }
  closeOprtnSideBar() {
    this.openOprtnSlider = false;
    this.oprtnsData = {};
  }
  getVehicles() {
    var fltrData = [
      {
        selectedtenant: this.selectedtenant,
        selectedvndr: 0,
        selectedctgry: 0,
      },
    ];
    this.showLdr = true;
    this.apiServ
      .post(fltrData, "drivers/vehicles/asgndvehicles")
      .subscribe((res) => {
        if (res["status"] == 200) {
          this.vhcleslst = res["data"];
          this.selectedVehicle = this.vhcleslst[0].asrt_id;
          this.showLdr = false;
        }
      });
  }
  onvehcleSelect(evt) {
    this.chngdVhcle = evt;
  }
  clearTrip() {
    // clear Trip
    var postData = {
      tnt_id: this.selectedtenant,
      asrt_id: this.oprtnsData.asrt_id,
      dt: this.curDate,
      trp_schde_id: this.oprtnsData.trp_schde_id,
      trp_rn_id: this.oprtnsData.trp_rn_id,
    };
    this.showLdr = true;

    if (this.oprtnsData.asrt_id) {
      this.apiServ
        .post(postData, `tripschedule/tripsDtls/clearTrip`)
        .subscribe((res) => {
          if (res["status"] == 200) {
            this.showLdr = false;
            this.createMessage("Success", `Trip Cleared successfully`);
          }
        });
    }
  }
  StartTrip() {
    var postData = this.oprtnsData;
    this.showLdr = true;
    if (this.oprtnsData.asrt_id) {
      this.apiServ
        .post(postData, `tripschedule/tripsDtls/startTrip`)
        .subscribe((res) => {
          if (res["status"] == 200) {
            this.showLdr = false;
            this.createMessage("Success", `Trip Started successfully`);
          }
        });
    }
  }
  cancelTrip() {
    var postData = this.oprtnsData;
    this.showLdr = true;
    if (this.oprtnsData.asrt_id) {
      this.apiServ
        .post(postData, `tripschedule/tripsDtls/cancelTrip`)
        .subscribe((res) => {
          if (res["status"] == 200) {
            this.showLdr = false;
            this.createMessage("Success", `Trip Canceled successfully`);
          }
        });
    }
  }
  submitVehicle() {
    var postData = this.oprtnsData;
    postData.chngdasrt = this.chngdVhcle;
    postData.rsn_tx = this.vhclChngeRsn;
    this.showLdr = true;
    console.log(postData);
    if (this.oprtnsData.asrt_id) {
      this.apiServ
        .post(postData, `tripschedule/tripsDtls/changeVhclForTrip`)
        .subscribe((res) => {
          console.log(res);
          if (res["status"] == 200) {
            this.showLdr = false;
            this.createMessage(
              "Success",
              `Vehicle Assigned to Trip successfully`
            );
            this.vhclChngeRsn = "";
            this.selectCategory(0, this.curDate);
          }
        });
    }
  }

  plotSvmBndsInMapWndw(svm_id) {
    this.trpsvmBndsLst = [];
    if (this.svmplypoint2) {
      for (var k = 0; k < this.svmplypoint2.length; k++) {
        this.map.removeLayer(this.svmplypoint2[k].ply);
      }
    }
    this.svmLst.forEach((s) => {
      if (s.svm_id == svm_id) {
        this.trpsvmBndsLst.push(s);
      }
    });
    // console.log(this.trpsvmBndsLst)
    for (var l = 0; l < this.trpsvmBndsLst.length; l++)
      if (this.trpsvmBndsLst[l].fnce_arc_lne_tx) {
        this.svmfncepolygon2 = L.polygon(
          JSON.parse(this.trpsvmBndsLst[l].fnce_arc_lne_tx) as [],
          { color: this.trpsvmBndsLst[l].fncs_clr_cd, fill: false }
        )
          .addTo(this.map)
          .bindTooltip(this.trpsvmBndsLst[l].svm_nm, {
            permanent: true,
            opacity: 0.7,
          })
          .openTooltip();
        this.svmplypoint2.push({
          ply: this.svmfncepolygon2,
          svm_id: this.trpsvmBndsLst[l].svm_id,
        });
        this.map.fitBounds(this.svmfncepolygon2.getBounds());
      }
  }
  downloadPdf() {
    console.log("downloadPdf called");
    console.log("Map exists:", !!this.map);
    console.log("Print button exists:", !!this.printbtn);

    if (!this.map) {
      this.message.warning(
        "Map not initialized. Please reload the map and try again."
      );
      return;
    }

    if (!this.printbtn) {
      console.error(
        "Print button not initialized. Checking if leaflet-easyprint is loaded..."
      );
      const leafletEasyPrint =
        (window as any).L?.easyPrint || (L as any).easyPrint;
      console.log("leaflet-easyprint available:", !!leafletEasyPrint);

      this.message.warning(
        "Map print button not initialized. Please close and reopen the map modal, then try again."
      );
      return;
    }

    try {
      // Show loading message
      const loadingMsg = this.message.loading("Generating map export...", {
        nzDuration: 0,
      }).messageId;

      // Ensure map is properly sized
      this.map.invalidateSize();

      // Small delay to ensure map is rendered
      setTimeout(() => {
        try {
          // Get the map container size
          const mapContainer = this.map.getContainer();
          if (!mapContainer) {
            this.message.remove(loadingMsg);
            this.message.error("Map container not found");
            return;
          }

          console.log("Calling printMap...");
          // Use leaflet-easyprint to export
          this.printbtn.printMap("CurrentSize", "TRACK_MAP");

          // Remove loading message after a delay
          setTimeout(() => {
            this.message.remove(loadingMsg);
            this.message.success(
              "Map exported successfully! Check your downloads."
            );
          }, 1500);
        } catch (e) {
          console.error("Error printing map:", e);
          this.message.remove(loadingMsg);
          this.message.error("Error exporting map: " + e.message);
        }
      }, 500);
    } catch (e) {
      console.error("Error printing map:", e);
      this.message.error("Error printing map. Please try again.");
    }
  }
  // openStoppage(c, dt) {
  //   this.vehicle_nu=c.asrt_nm
  //   this.showLdr = true;
  //   this.stpgPnts = []
  //   this.points = []
  //   console.log(c)

  //   if (c.actl_strt_ts != null && c.actl_end_ts != null) {

  //     this.curDate = moment(dt).format('YYYY-MM-DD');
  //     this.rte_id = c.rte_id;
  //     this.postslctdDt = {
  //       "checkbit": "byVeh",
  //       "sdate": this.datepipe.transform(c.actl_strt_ts, 'yyyy-MM-dd HH:mm'),
  //       "edate": this.datepipe.transform(c.actl_end_ts, 'yyyy-MM-dd HH:mm'),
  //       "asrt_id": c.asrt_id,
  //       "trp_rn_id": c.trp_rn_id
  //     }
  //     this.apiServ.post(this.postslctdDt, 'playback/vehicle/playback').subscribe((res) => {
  //       this.stpgDtls = true
  //       var playData = res['data'];
  //       if (playData !== '' && playData.lat.length > 0) {
  //         this.showLdr = false;
  //         console.log(playData);
  //         for (var c = 0; c < playData.lat.length; c++) {

  //           if (playData.lat[c] != playData.lat[0] && playData.lng[c] != playData.lng[0]) {
  //             this.points.push({
  //               lat: playData.lat[c],
  //               lng: playData.lng[c],
  //               speed_ct: playData.mapPoints[c].speed_ct,
  //               Signal: playData.mapPoints[c].Signall,
  //               asrt_nm: playData.mapPoints[c].asrt_nm,
  //               drcn_ct: playData.mapPoints[c].drcn_ct
  //             });
  //           }
  //         }
  //         this.points.push({
  //           lat: playData.lat[playData.lat.length - 1],
  //           lng: playData.lng[playData.lat.length - 1],
  //           Signal: playData.mapPoints[playData.lat.length - 1].Signall != undefined ? playData.mapPoints[playData.lat.length - 1].Signall : '',
  //           asrt_nm: playData.mapPoints[playData.lat.length - 1].asrt_nm,
  //         });

  //         var trvlDstnce = playData.mapPoints[playData.mapPoints.length - 1].odmtr_ct - playData.mapPoints[0].odmtr_ct;
  //         var totDtnce = Math.ceil(trvlDstnce);
  //         this.travelDist = totDtnce + ' ' + 'Kms';

  //         var pstrt;
  //         var pend;
  //         var sno = 0;
  //         console.log(this.points)
  //         for (var m = 0; m < this.points.length; m++) {
  //           var startTime;
  //           var endTime;

  //           if (this.points[m].speed_ct == 0) {
  //             if (this.points[m].Signal == undefined) {
  //               pstrt = this.points[m + 1].Signal;

  //             } else {
  //               pstrt = this.points[m].Signal;
  //             }
  //             pend = this.points[m + 1].Signal;

  //             this.stoppageTime = moment(pend, "DD-MM-YYYY HH:mm").diff(moment(pstrt, "DD-MM-YYYY HH:mm"));
  //             this.points[m]["stoppageTime"] = this.stoppageTime / 60000;
  //             this.points[m]["lastTime"] = this.points[m + 1].Signal;
  //             this.points[m]["Timing"] = pstrt + " to " + pend
  //             if (this.stoppageTime != 0) {
  //               this.points[m]["Sno"] = ++sno;
  //               this.points[m]["Vehicle"] =this.vehicle_nu;
  //               this.points[m]["latlng"] = this.points[m].lat + "," + this.points[m].lng;
  //               this.points[m]["parkingpoint"] = "parking point" + "-" + sno;
  //               this.stpgPnts.push(this.points[m])
  //             }

  //           }
  //         }
  //         console.log(this.stpgPnts)
  //         this.columnDefs = [
  //           { headerName: 'S.No', field: 'Sno', alignment: 'center', width: 60, filter: false, cellClass: 'pm-grid-number-cell', search: false },
  //           { headerName: 'vehicle', field: 'vehicle', alignment: 'center', width: 60, filter: false, cellClass: 'pm-grid-number-cell', search: false },
  //           { headerName: 'Parking Point', field: 'parkingpoint', alignment: 'left', filter: false, cellClass: 'pm-grid-number-cell', search: true },
  //           { headerName: 'Stoppage Between', field: 'Timing', alignment: 'left', filter: false, cellClass: 'pm-grid-number-cell', search: true },
  //           { headerName: 'Latitude And Longitude', field: 'latlng', alignment: 'left', filter: false, cellClass: 'pm-grid-number-cell', search: true },
  //           { headerName: 'Stoppage Time (In MIN)', alignment: 'left', width: 150, field: 'stoppageTime', cellClass: 'pm-grid-number-cell' },
  //         ]
  //       } else {
  //         this.showLdr = false;
  //         this.createMessage('warning', 'Travelled Route not found!!!!');
  //       }
  //     })

  //   }
  //   else {
  //     this.showLdr = false;
  //     this.createMessage('warning', 'Travelled Route not found!!!!');
  //   }
  // }
  handleOk(): void {
    this.stpgDtls = false;
  }

  handlestoppage(): void {
    this.stpgDtls = false;
  }
  vewonMap(f) {
    console.log(f);
    var latitude = f.lat;
    var longitude = f.lng;
    var mapUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(mapUrl, "_blank");
  }
  dnldPrkngDta(c) {
    console.log(c);
    this.vehicle_nu = c.asrt_nm;
    this.showLdr = true;
    this.stpgPnts = [];
    this.points = [];
    this.postslctdDt = {
      checkbit: "byallTrips",
      asrt_id: c.asrt_id,
      device: c.dev_imei_nu,
      date: this.slctdDt,
    };
    // if (c.actl_strt_ts != null && c.actl_end_ts != null) {

    this.apiServ
      .post(this.postslctdDt, "playback/vehicle/playback")
      .subscribe((res) => {
        var playData = res["data"];
        this.stpgDtls = true;
        this.showLdr = true;
        console.log(playData);
        if (playData !== "" && playData.lat.length > 0) {
          this.showLdr = false;
          console.log(playData);
          for (var c = 0; c < playData.lat.length; c++) {
            if (
              playData.lat[c] != playData.lat[0] &&
              playData.lng[c] != playData.lng[0]
            ) {
              this.points.push({
                lat: playData.lat[c],
                lng: playData.lng[c],
                speed_ct: playData.mapPoints[c].speed_ct,
                Signal: playData.mapPoints[c].Signall,
                asrt_nm: playData.mapPoints[c].asrt_nm,
                drcn_ct: playData.mapPoints[c].drcn_ct,
              });
            }
          }
          this.points.push({
            lat: playData.lat[playData.lat.length - 1],
            lng: playData.lng[playData.lat.length - 1],
            Signal:
              playData.mapPoints[playData.lat.length - 1].Signall != undefined
                ? playData.mapPoints[playData.lat.length - 1].Signall
                : "",
            asrt_nm: playData.mapPoints[playData.lat.length - 1].asrt_nm,
          });

          var trvlDstnce =
            playData.mapPoints[playData.mapPoints.length - 1].odmtr_ct -
            playData.mapPoints[0].odmtr_ct;
          var totDtnce = Math.ceil(trvlDstnce);
          this.travelDist = totDtnce + " " + "Kms";

          var pstrt;
          var pend;
          var sno = 0;
          console.log(this.points);
          for (var m = 0; m < this.points.length; m++) {
            var startTime;
            var endTime;

            if (this.points[m].speed_ct == 0) {
              if (this.points[m].Signal == undefined) {
                pstrt = this.points[m + 1].Signal;
              } else {
                pstrt = this.points[m].Signal;
              }
              pend = this.points[m + 1].Signal;

              this.stoppageTime = moment(pend, "DD-MM-YYYY HH:mm").diff(
                moment(pstrt, "DD-MM-YYYY HH:mm")
              );
              this.points[m]["stoppageTime"] = this.stoppageTime / 60000;
              this.points[m]["lastTime"] = this.points[m + 1].Signal;
              this.points[m]["Timing"] = pstrt + " to " + pend;
              this.points[m]["Timing_strt"] = pstrt;
              this.points[m]["Timing_end"] = pend;
              if (this.stoppageTime != 0) {
                this.points[m]["Sno"] = ++sno;
                this.points[m]["vehicle"] = this.vehicle_nu;
                this.points[m]["latlng"] =
                  this.points[m].lat + "," + this.points[m].lng;
                this.points[m]["parkingpoint"] = "parking point" + "-" + sno;
                this.stpgPnts.push(this.points[m]);
              }
            }
          }
          console.log(this.stpgPnts);
          this.columnDefs = [
            {
              headerName: "S.No",
              field: "Sno",
              alignment: "center",
              width: 60,
              filter: false,
              cellClass: "pm-grid-number-cell",
              search: false,
            },
            {
              headerName: "vehicle",
              field: "vehicle",
              alignment: "center",
              width: 100,
              filter: false,
              cellClass: "pm-grid-number-cell",
              search: false,
            },
            {
              headerName: "Parking Point",
              field: "parkingpoint",
              alignment: "left",
              filter: false,
              cellClass: "pm-grid-number-cell",
              search: true,
            },
            {
              headerName: "Stoppage Between",
              field: "Timing",
              alignment: "left",
              filter: false,
              cellClass: "pm-grid-number-cell",
              search: true,
            },
            {
              headerName: "Latitude And Longitude",
              field: "latlng",
              alignment: "left",
              filter: false,
              cellClass: "pm-grid-number-cell",
              search: true,
            },
            {
              headerName: "Stoppage Time (In MIN)",
              alignment: "left",
              width: 150,
              field: "stoppageTime",
              cellClass: "pm-grid-number-cell",
            },
          ];
        } else {
          this.showLdr = false;
          this.createMessage("warning", "Travelled Route not found!!!!");
        }
      });

    // }
    // else {
    //   this.showLdr = false;
    //   this.createMessage('warning', 'Travelled Route not found!!!!');
    // }
  }
  closePrkng() {
    this.prkngOpn = false;
  }

  fltrs() {
    this.filters = !this.filters;
  }

  goBackToStateDashboard() {
    this.router.navigate([`internal/dashboard/state-trips-dashboard`]);
  }

  private buildPlaybackParkingPoints(routeData: any[], tripCtx: any): any[] {
    if (!Array.isArray(routeData) || routeData.length === 0) {
      return [];
    }

    // Map route data to PlaybackService format
    const playbackPoints = routeData.map((pt) => ({
      lat: Number(pt.lat),
      lng: Number(pt.lng),
      speed_ct: pt.spd_ct !== undefined ? Number(pt.spd_ct) : undefined,
      Signal: pt.Signal,
      asrt_nm: tripCtx?.asrt_nm,
      drcn_ct: pt.drcn_ct,
    }));

    // Use PlaybackService deterministic calculation (same as tracking component)
    const calculationResult =
      this.playbackService.calculateParkingPointsDeterministic(playbackPoints);

    // Convert parking points to the format expected by plotParkingMarkers
    const parkingMarkerPoints = calculationResult.parkingPoints.map(
      (parking) => ({
        Sno: parking.parkingNumber,
        lat: parking.lat,
        lng: parking.lng,
        Signal: parking.startTime,
        lastTime: parking.endTime,
        stoppageTime: parking.durationMinutes,
        asrt_nm: tripCtx?.asrt_nm,
      })
    );

    console.log(
      `[Parking] Deterministic Result: ${calculationResult.totalCount} points, ` +
        `total duration: ${calculationResult.totalDurationMinutes} min`
    );

    return parkingMarkerPoints;
  }

  private plotParkingMarkers(points: any[], vehicleName: string) {
    if (this._parkingMarkersLayer) {
      this._parkingMarkersLayer.clearLayers();
      this.routemap.removeLayer(this._parkingMarkersLayer);
    }
    this.finalSpdMrkrs = [];
    this._parkingMarkersLayer = L.layerGroup();
    this.parkingMarkerGroups = new Map();

    let plotted = 0;
    points.forEach((point) => {
      if (
        point &&
        point.stoppageTime &&
        point.stoppageTime > 0 &&
        !isNaN(point.lat) &&
        !isNaN(point.lng)
      ) {
        plotted++;
        const markerColor = point.stoppageTime >= 10 ? "#dc3545" : "#6f42c1";
        const customParkingIcon = L.divIcon({
          className: "custom-parking-marker",
          html: `<div style="
            background-color: ${markerColor};
            color: white;
            width: 25px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid ${markerColor};
            border-radius: 4px;
            font-weight: bold;
            font-size: 10px;
            box-shadow: 0 2px 5px rgba(0,0,0,0.3);
            font-family: Arial, sans-serif;
          ">P${point.Sno || plotted}</div>`,
          iconSize: [25, 25],
          iconAnchor: [12, 12],
          popupAnchor: [0, -12],
        });

        const marker = L.marker([point.lat, point.lng], {
          icon: customParkingIcon,
          zIndexOffset: 1000 + plotted,
          data: {
            sno: point.Sno || plotted,
            Sno: point.Sno || plotted,
            asrt_nm: vehicleName,
            Signal: point.Signal,
            lastTime: point.lastTime,
            stoppageTime: point.stoppageTime,
            lat: point.lat,
            lng: point.lng,
          },
        }).bindPopup(`
          <div style="min-width: 200px;">
            <b>Parking Point P${point.Sno || plotted}</b><br>
            <b>Vehicle No:</b> ${vehicleName}<br>
            <b>From:</b> ${point.Signal}<br>
            <b>To:</b> ${point.lastTime}<br>
            <b>Duration:</b> ${point.stoppageTime} Minutes<br>
            <b>Location:</b> ${point.lat?.toFixed(6)}, ${point.lng?.toFixed(6)}
          </div>
        `);

        this._parkingMarkersLayer.addLayer(marker);
        this.finalSpdMrkrs.push(marker);

        const coordKey = `${point.lat.toFixed(6)}_${point.lng.toFixed(6)}`;
        if (!this.parkingMarkerGroups.has(coordKey)) {
          this.parkingMarkerGroups.set(coordKey, {
            markers: [],
            expanded: false,
            legs: [],
            baseLatLng: L.latLng(point.lat, point.lng),
            lastClicked: null,
          });
        }
        const group = this.parkingMarkerGroups.get(coordKey);
        (marker as any).__baseLatLng = L.latLng(point.lat, point.lng);
        group.markers.push(marker);
      }
    });

    if (plotted > 0) {
      this._parkingMarkersLayer.addTo(this.routemap);
      console.log(`Parking markers plotted using playback logic: ${plotted}`);
      this.attachParkingSpiderifyHandlers();
    } else {
      console.log("No parking markers to plot for this trip.");
    }
  }

  private attachParkingSpiderifyHandlers() {
    if (!this.parkingMarkerGroups) {
      return;
    }
    this.parkingMarkerGroups.forEach((group, coordKey) => {
      if (group.markers.length < 2) {
        return;
      }
      group.markers.forEach((marker) => {
        marker.off("click");
        marker.on("click", (e: L.LeafletMouseEvent) => {
          e.originalEvent?.stopPropagation();
          this.toggleSpiderifyGroup(coordKey, marker);
        });
      });
    });
  }

  private toggleSpiderifyGroup(coordKey: string, marker: L.Marker) {
    const group = this.parkingMarkerGroups?.get(coordKey);
    if (!group || group.markers.length < 2) {
      marker.openPopup();
      return;
    }
    if (!group.expanded) {
      this.expandSpiderGroup(group, marker);
      return;
    }
    if (group.expanded && group.lastClicked === marker) {
      this.collapseSpiderGroup(group);
      return;
    }
    group.lastClicked = marker;
    setTimeout(() => marker.openPopup(), 0);
  }

  private expandSpiderGroup(
    group: {
      markers: L.Marker[];
      expanded: boolean;
      legs: L.Polyline[];
      baseLatLng: L.LatLng;
      lastClicked: L.Marker | null;
    },
    clickedMarker?: L.Marker
  ) {
    const total = group.markers.length;
    const radiusMeters = 12; // distance between spider legs
    const base = group.baseLatLng;

    group.legs.forEach((leg) => this.routemap.removeLayer(leg));
    group.legs = [];

    group.markers.forEach((marker, index) => {
      const angle = (2 * Math.PI * index) / total;
      const offsetLatLng = this.offsetLatLng(base, radiusMeters, angle);
      marker.setLatLng(offsetLatLng);

      const leg = L.polyline([base, offsetLatLng], {
        color: "#666",
        weight: 1,
        opacity: 0.6,
        dashArray: "2,2",
      }).addTo(this.routemap);
      group.legs.push(leg);
    });
    group.expanded = true;
    group.lastClicked = clickedMarker || null;
    if (clickedMarker) {
      setTimeout(() => clickedMarker.openPopup(), 0);
    }
  }

  private collapseSpiderGroup(group: {
    markers: L.Marker[];
    expanded: boolean;
    legs: L.Polyline[];
    baseLatLng: L.LatLng;
    lastClicked: L.Marker | null;
  }) {
    group.markers.forEach((marker) => {
      const base = (marker as any).__baseLatLng;
      if (base) {
        marker.setLatLng(base);
      }
    });
    group.legs.forEach((leg) => this.routemap.removeLayer(leg));
    group.legs = [];
    group.expanded = false;
    group.lastClicked = null;
  }

  private offsetLatLng(
    origin: L.LatLng,
    meters: number,
    angleRad: number
  ): L.LatLng {
    const earthRadius = 6378137; // meters
    const dLat = (meters * Math.cos(angleRad)) / earthRadius;
    const dLng =
      (meters * Math.sin(angleRad)) /
      (earthRadius * Math.cos((origin.lat * Math.PI) / 180));

    const lat = origin.lat + (dLat * 180) / Math.PI;
    const lng = origin.lng + (dLng * 180) / Math.PI;
    return L.latLng(lat, lng);
  }

  toggleCardDetails(index: number, event: Event): void {
    event.stopPropagation();
    if (this.expandedCards.has(index)) {
      this.expandedCards.delete(index);
    } else {
      this.expandedCards.add(index);
    }
  }

  isCardExpanded(index: number): boolean {
    return this.expandedCards.has(index);
  }

  toggleSearchFilters(): void {
    this.showSearchFilters = !this.showSearchFilters;
  }
}
